import React, { useState } from "react";
import {
  makeStyles,
  Button,
  Modal,
  Backdrop,
  FormControl,
  InputAdornment,
  IconButton,
  Select,
  MenuItem,
  Typography,
} from "@material-ui/core";

import "./CSS/vrfhacim.css";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";
import axiosInstance from '../services/axiosConfig';

import { Input } from "@mui/material";
import Store from "../Store/Store";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import {
  SET_FETCH_TAG_VALUE_CONTROL,
  set_vrfhacim_tags,
  set_external_trend_info,
  set_combine_trends,
} from "../Action/Action";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    display: "flex",
    justifyContent: "space-around",
    flexWrap: "wrap",
    flex: 1,
    gap: "3px",

    marginTop: "13%",
    marginLeft: "1%",
  },

  topButtonContainer: {
    position: "absolute",
    top: "4%",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    justifyContent: "center",
  },

  pageroot: {
    width: "100%",
    height: "100vh",
    display: "flex",
    position: "relative",
  },

  lockButton: {
    marginLeft: theme.spacing(1),
  },
  floorTitle: {
    position: "absolute",
    top: "9%",
    left: "50%",
    transform: "translateX(-50%)",
    fontSize: "2rem !important",
    fontWeight: 600,
    color: "black",
    padding: theme.spacing(1),
  },
  navigationButtonForward: {
    borderRadius: "15px",
    backgroundColor: "#fff",
    border: "3px solid rgba(238, 200, 108, 0.99)",
    fontWeight: 600,
  },
  navigationButtonBack: {
    borderRadius: "15px",
    backgroundColor: "#fff",
    border: "3px solid rgba(238, 200, 108, 0.99)",
    fontWeight: 600,
  },
  button: {
    backgroundColor: "lightgray",
    border: "2px solid rgb(67, 51, 22)",
    height: "5rem",
    width: "16rem",
    fontSize: "0.8rem",
    fontWeight: 700,

    whiteSpace: "nowrap",

    borderRadius: "20px",
    "&:focus": {
      outline: "none",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid rgb(237, 188, 69)",
    boxShadow: theme.shadows[5],
    maxWidth: 400,
    minWidth: 350,
    padding: theme.spacing(2, 5.5, 3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    position: "relative",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  statusRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    height: "3rem",
    padding: theme.spacing(1),
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  sogutmaısıtma: {
    padding: theme.spacing(1),
    "&:not(:last-child)": {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  statusLabel: {
    marginRight: theme.spacing(2),
    minWidth: "150px",
    fontWeight: 600,
  },
  formControl: {
    flexGrow: 1,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  select: {
    width: "100%",
  },
}));

const initalState = [
  {
    // LOBİ
    801: [
      { text: "Oda Sıcaklığı", tagId: "973" },
      { text: "Oda Set Değeri", tagId: "1117", device: "9233" },
      { text: "Cihaz", tagId: "1341", tagId2: "1457", device: "9230" },
      { text: "Çalışma Modu", tagId: "2702", tagId2: "2857", device: "9231" },
      { text: "Çalışma Durumu", tagId: "2702" },
      { text: "Fan Modu", tagId: "8157", tagId2: "2858" },

      { text: "Filtre Durumu", tagId: "1343" },
      { text: "Filtre Reset", tagId: "1619" },
      { text: "Arıza Durumu", tagId: "7234" },
      { text: "Arıza Kodu", tagId: "2701" },
    ],
  },
  {
    // DESK ÜSTÜ
    802: [
      { text: "Oda Sıcaklığı", tagId: "974" },
      { text: "Oda Set Değeri", tagId: "1123", device: "9238" },
      { text: "Cihaz", tagId: "1345", tagId2: "1458", device: "9235" },
      { text: "Çalışma Modu", tagId: "2706", tagId2: "2860", device: "9236" },
      { text: "Çalışma Durumu", tagId: "2706" },

      { text: "Fan Modu", tagId: "8161", tagId2: "2861" },

      { text: "Filtre Durumu", tagId: "1347" },
      { text: "Filtre Reset", tagId: "1626" },
      { text: "Arıza Durumu", tagId: "7237" },
      { text: "Arıza Kodu", tagId: "2705" },
    ],
  },
  {
    // GÜVELİK OFİSİ
    803: [
      { text: "Oda Sıcaklığı", tagId: "975" },
      { text: "Oda Set Değeri", tagId: "1129", device: "9243" },
      { text: "Cihaz", tagId: "1349", tagId2: "1459", device: "9240" },
      { text: "Çalışma Modu", tagId: "2710", tagId2: "2863", device: "9241" },
      { text: "Çalışma Durumu", tagId: "2710" },
      { text: "Fan Modu", tagId: "8165", tagId2: "2864" },

      { text: "Filtre Durumu", tagId: "1351" },
      { text: "Filtre Reset", tagId: "1633" },
      { text: "Arıza Durumu", tagId: "7340" },
      { text: "Arıza Kodu", tagId: "2709" },
    ],
  },
  {
    // BULAŞIKHANE
    804: [
      { text: "Oda Sıcaklığı", tagId: "976" },
      { text: "Oda Set Değeri", tagId: "1135", device: "9248" },
      { text: "Cihaz", tagId: "1353", tagId2: "1460", device: "9245" },
      { text: "Çalışma Modu", tagId: "2714", tagId2: "2866", device: "9246" },
      { text: "Çalışma Durumu", tagId: "2714" },

      { text: "Fan Modu", tagId: "8169", tagId2: "2867" },

      { text: "Filtre Durumu", tagId: "1355" },
      { text: "Filtre Reset", tagId: "1640" },
      { text: "Arıza Durumu", tagId: "7243" },
      { text: "Arıza Kodu", tagId: "2713" },
    ],
  },
  {
    // YEMEKHANE 1
    805: [
      { text: "Oda Sıcaklığı", tagId: "977" },
      { text: "Oda Set Değeri", tagId: "1141", device: "9253" },
      { text: "Cihaz", tagId: "1357", tagId2: "1461", device: "9250" },
      { text: "Çalışma Modu", tagId: "2718", tagId2: "2869", device: "9251" },
      { text: "Çalışma Durumu", tagId: "2718" },
      { text: "Fan Modu", tagId: "8173", tagId2: "2870" },

      { text: "Filtre Durumu", tagId: "1359" },
      { text: "Filtre Reset", tagId: "1647" },
      { text: "Arıza Durumu", tagId: "7246" },
      { text: "Arıza Kodu", tagId: "2717" },
    ],
  },
  {
    // YEMEKHANE 2
    806: [
      { text: "Oda Sıcaklığı", tagId: "978" },
      { text: "Oda Set Değeri", tagId: "1147", device: "9258" },
      { text: "Cihaz", tagId: "1361", tagId2: "1462", device: "9255" },
      { text: "Çalışma Modu", tagId: "2722", tagId2: "2872", device: "9256" },
      { text: "Çalışma Durumu", tagId: "2722" },

      { text: "Fan Modu", tagId: "8177", tagId2: "2873" },

      { text: "Filtre Durumu", tagId: "1363" },
      { text: "Filtre Reset", tagId: "1654" },
      { text: "Arıza Durumu", tagId: "7249" },
      { text: "Arıza Kodu", tagId: "2721" },
    ],
  },
  {
    // FOR FUN BAR
    807: [
      { text: "Oda Sıcaklığı", tagId: "979" },
      { text: "Oda Set Değeri", tagId: "1153", device: "9263" },
      { text: "Cihaz", tagId: "1365", tagId2: "1463", device: "9260" },
      { text: "Çalışma Modu", tagId: "2726", tagId2: "2875", device: "9261" },
      { text: "Çalışma Durumu", tagId: "2726" },
      { text: "Fan Modu", tagId: "8181", tagId2: "2876" },

      { text: "Filtre Durumu", tagId: "1367" },
      { text: "Filtre Reset", tagId: "1661" },
      { text: "Arıza Durumu", tagId: "7252" },
      { text: "Arıza Kodu", tagId: "2725" },
    ],
  },
  {
    // FOR FUN WC
    808: [
      { text: "Oda Sıcaklığı", tagId: "980" },
      { text: "Oda Set Değeri", tagId: "1159", device: "9268" },
      { text: "Cihaz", tagId: "1369", tagId2: "1464", device: "9265" },
      { text: "Çalışma Modu", tagId: "2730", tagId2: "2878", device: "9266" },
      { text: "Çalışma Durumu", tagId: "2730" },

      { text: "Fan Modu", tagId: "8185", tagId2: "2879" },

      { text: "Filtre Durumu", tagId: "1371" },
      { text: "Filtre Reset", tagId: "1668" },
      { text: "Arıza Durumu", tagId: "7255" },
      { text: "Arıza Kodu", tagId: "2729" },
    ],
  },
  {
    // FOR FUN WC 2
    809: [
      { text: "Oda Sıcaklığı", tagId: "981" },
      { text: "Oda Set Değeri", tagId: "1165", device: "9273" },
      { text: "Cihaz", tagId: "1373", tagId2: "1465", device: "9270" },
      { text: "Çalışma Modu", tagId: "8732", tagId2: "8731", device: "9271" },
      { text: "Çalışma Durumu", tagId: "8732" },
      { text: "Fan Modu", tagId: "8189", tagId2: "2881" },

      { text: "Filtre Durumu", tagId: "1375" },
      { text: "Filtre Reset", tagId: "1675" },
      { text: "Arıza Durumu", tagId: "7258" },
      { text: "Arıza Kodu", tagId: "2733" },
    ],
  },
  {
    // KARAOKE 1
    810: [
      { text: "Oda Sıcaklığı", tagId: "982" },
      { text: "Oda Set Değeri", tagId: "1171", device: "9278" },
      { text: "Cihaz", tagId: "1377", tagId2: "1466", device: "9275" },
      { text: "Çalışma Modu", tagId: "2738", tagId2: "2884", device: "9276" },
      { text: "Çalışma Durumu", tagId: "2738" },

      { text: "Fan Modu", tagId: "8193", tagId2: "2885" },

      { text: "Filtre Durumu", tagId: "1379" },
      { text: "Filtre Reset", tagId: "1681" },
      { text: "Arıza Durumu", tagId: "7261" },
      { text: "Arıza Kodu", tagId: "2737" },
    ],
  },
  {
    // DANS ODASI
    811: [
      { text: "Oda Sıcaklığı", tagId: "983" },
      { text: "Oda Set Değeri", tagId: "1177", device: "9283" },
      { text: "Cihaz", tagId: "1381", tagId2: "1467", device: "9280" },
      { text: "Çalışma Modu", tagId: "2742", tagId2: "2887", device: "9281" },
      { text: "Çalışma Durumu", tagId: "2742" },
      { text: "Fan Modu", tagId: "8197", tagId2: "2888" },

      { text: "Filtre Durumu", tagId: "1383" },
      { text: "Filtre Reset", tagId: "1688" },
      { text: "Arıza Durumu", tagId: "7264" },
      { text: "Arıza Kodu", tagId: "2741" },
    ],
  },
  {
    // KARAOKE 2
    812: [
      { text: "Oda Sıcaklığı", tagId: "984" },
      { text: "Oda Set Değeri", tagId: "1183", device: "9288" },
      { text: "Cihaz", tagId: "1385", tagId2: "1468", device: "9285" },
      { text: "Çalışma Modu", tagId: "2746", tagId2: "2890", device: "9286" },
      { text: "Çalışma Durumu", tagId: "2746" },

      { text: "Fan Modu", tagId: "8201", tagId2: "2891" },

      { text: "Filtre Durumu", tagId: "1387" },
      { text: "Filtre Reset", tagId: "1695" },
      { text: "Arıza Durumu", tagId: "7267" },
      { text: "Arıza Kodu", tagId: "2745" },
    ],
  },
  {
    // OYUN SALONU TEKNİK ÖNÜ
    813: [
      { text: "Oda Sıcaklığı", tagId: "985" },
      { text: "Oda Set Değeri", tagId: "1189", device: "9293" },
      { text: "Cihaz", tagId: "1389", tagId2: "1469", device: "9290" },
      { text: "Çalışma Modu", tagId: "2750", tagId2: "2893", device: "9291" },
      { text: "Çalışma Durumu", tagId: "2750" },
      { text: "Fan Modu", tagId: "8205", tagId2: "2894" },

      { text: "Filtre Durumu", tagId: "1391" },
      { text: "Filtre Reset", tagId: "1702" },
      { text: "Arıza Durumu", tagId: "7270" },
      { text: "Arıza Kodu", tagId: "2749" },
    ],
  },
  // {
  //   // LAZER ALANI
  //   814: [
  //     { text: "Oda Sıcaklığı", tagId: "5059" },
  //     { text: "Oda Set Değeri", tagId: "8706" },
  //     { text: "Cihaz", tagId: "8713", tagId2: "8710" },
  //     { text: "Çalışma Modu", tagId: "8719", tagId2: "8725" },
  //     { text: "Çalışma Durumu", tagId: "8719" },

  //     { text: "Fan Modu", tagId: "8209", tagId2: "8726" },

  //     { text: "Filtre Durumu", tagId: "8714" },
  //     { text: "Filtre Reset", tagId: "8722" },
  //     { text: "Arıza Durumu", tagId: "7273" },
  //     { text: "Arıza Kodu", tagId: "8720" },
  //   ],
  // },
  // {
  //   // LAZER ALANI 2
  //   815: [
  //     { text: "Oda Sıcaklığı", tagId: "5060" },
  //     { text: "Oda Set Değeri", tagId: "8703" },
  //     { text: "Cihaz", tagId: "8711", tagId2: "8709" },
  //     { text: "Çalışma Modu", tagId: "8717", tagId2: "8723" },
  //     { text: "Çalışma Durumu", tagId: "8717" },
  //     { text: "Fan Modu", tagId: "8213", tagId2: "8724" },

  //     { text: "Filtre Durumu", tagId: "8712" },
  //     { text: "Filtre Reset", tagId: "8721" },
  //     { text: "Arıza Durumu", tagId: "7276" },
  //     { text: "Arıza Kodu", tagId: "8718" },
  //   ],
  // },
  // {
  //   // LAZER ALANI 3
  //   816: [
  //     { text: "Oda Sıcaklığı", tagId: "5061" },
  //     { text: "Oda Set Değeri", tagId: "8706" },
  //     { text: "Cihaz", tagId: "8713", tagId2: "8710" },
  //     { text: "Çalışma Modu", tagId: "8719", tagId2: "8725" },
  //     { text: "Çalışma Durumu", tagId: "8719" },

  //     { text: "Fan Modu", tagId: "8217", tagId2: "8726" },

  //     { text: "Filtre Durumu", tagId: "8714" },
  //     { text: "Filtre Reset", tagId: "8722" },
  //     { text: "Arıza Durumu", tagId: "7279" },
  //     { text: "Arıza Kodu", tagId: "8720" },
  //   ],
  // },
];

let revisedState = {};

initalState.forEach((room) => {
  const roomId = Object.keys(room)[0];
  const roomTags = room[roomId];

  roomTags.forEach((tag) => {
    const text = tag.text;
    const tagId = tag.tagId;

    if (!revisedState[text]) {
      revisedState[text] = [];
    }

    revisedState[text].push(tagId);
  });
});
const inital_func = () => {
  var obj__ = [];
  var obj2__ = [];

  initalState.forEach((item) => {
    Object.entries(item).forEach((a) => {
      obj__.push(a[1]);
    });
  });

  obj__.forEach((item2) => {
    item2.forEach((item3) => {
      obj2__.push({ tagId: item3.tagId });
      // tagId2 varsa onu da ekleyelim
      if (item3.tagId2) {
        obj2__.push({ tagId: item3.tagId2 });
      }else if(item3.device)               obj2__.push({ tagId: item3.device });
    });
  });

  setInterval(() => {
    const fetch_tag_values = async () => {
      if (window.location.pathname === "/vrfhacim") {
        try {
          const request = await axiosInstance.post(
            "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
            obj2__
          );
          const response = request.data;

          const updatedResponse = response.map((item) => {
            const matchedItem = obj2__.find(
              (objItem) => objItem.tagId === item.tagId
            );
            return {
              ...item,
              tagId2: matchedItem ? matchedItem.tagId : null,
            };
          });

          Store.dispatch(set_vrfhacim_tags(response));
        } catch (err) {
          console.log(err);
        } finally {
          Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
        }
      }
    };
    fetch_tag_values();
  }, 1000);
};

setTimeout(() => {
  inital_func();
}, 100);

const VRFHacim = (props) => {
  const classes = useStyles();

  const [render_state, Set_render_state] = useState([]);

  useEffect(() => {
    Set_render_state(props.vrfhacim_tags);
  }, [props.vrfhacim_tags]);
  const [open, setOpen] = useState(Array(13).fill(false));

  const [state, Set_state] = useState(initalState);

  const history = useHistory();

  const [locked, setLocked] = useState({
    801: { odasetdegeri: false },
    802: { odasetdegeri: false },
    803: { odasetdegeri: false },
    804: { odasetdegeri: false },
    805: { odasetdegeri: false },
    806: { odasetdegeri: false },
    807: { odasetdegeri: false },
    808: { odasetdegeri: false },
    809: { odasetdegeri: false },
    810: { odasetdegeri: false },
    811: { odasetdegeri: false },
    812: { odasetdegeri: false },
    813: { odasetdegeri: false },
    814: { odasetdegeri: false },
    815: { odasetdegeri: false },
    816: { odasetdegeri: false },
  });

  //yetkilendirme
  const [vrf_okuma_control, Set_vrf_okuma_control] = useState(false);

  useEffect(() => {
    if (props.yetkilendirme && props.uid !== "") {
      let data = props.yetkilendirme;
      let newObj = data[props.uid];
      if (newObj !== undefined) {
        if (newObj["VRF"]["Y"] === "t") {
          Set_vrf_okuma_control(true);
        } else {
          Set_vrf_okuma_control(false);
        }
      }
    }
  }, [props.yetkilendirme]);

  const [active_room_number, Set_active_room_number] = useState(null);

  const toggleLock = (roomNumber, selectType) => {
    setLocked((prevLocked) => {
      const newLocked = {
        ...prevLocked,
        [roomNumber]: {
          ...prevLocked[roomNumber],
          [selectType]: !prevLocked[roomNumber]?.[selectType],
        },
      };
      console.log("kilitlendi:", newLocked);
      return newLocked;
    });
  };

  const handleOpen = (index) => {
    let newOpen = [...open];
    newOpen[index] = true;
    setOpen(newOpen);
  };

  const handleClose = (roomNumber) => {
    const index = roomNumber - 801;
    let newOpen = [...open];
    newOpen[index] = false;
    setOpen(newOpen);
    Set_active_room_number(null);
  };

  const [cihazselectValue, setcihazSelectValue] = useState({
    801: "ON",
    802: "ON",
    803: "ON",
    804: "ON",
    805: "ON",
    806: "ON",
    807: "ON",
    808: "ON",
    809: "ON",
    810: "ON",
    811: "ON",
    812: "ON",
    813: "ON",
    814: "ON",
    815: "ON",
    816: "ON",
  });

  const [cihazled, Setcihazled] = useState({
    801: "green",
    802: "green",
    803: "green",
    804: "green",
    805: "green",
    806: "green",
    807: "green",
    808: "green",
    809: "green",
    810: "green",
    811: "green",
    812: "green",
    813: "green",
    814: "green",
    815: "green",
    816: "green",
  });

  const CihazSelectChange = (event) => {
    setcihazSelectValue(event.target.value);
  };
  const [calismamoduselectValue, setcalismamoduSelectValue] = useState({
    801: "ISITMA",
    802: "ISITMA",
    803: "ISITMA",
    804: "ISITMA",
    805: "ISITMA",
    806: "ISITMA",
    807: "ISITMA",
    808: "ISITMA",
    809: "ISITMA",
    810: "ISITMA",
    811: "ISITMA",
    812: "ISITMA",
    813: "ISITMA",
    814: "ISITMA",
    815: "ISITMA",
    816: "ISITMA",
  });

  const CalismaModuSelectChange = (event, roomNumber) => {
    var newObj = calismamoduselectValue;
    newObj[roomNumber] = event.target.value;

    setcalismamoduSelectValue(newObj);
  };
  const [fanmoduselectValue, setfanmoduSelectValue] = useState({
    801: "1",
    802: "1",
    803: "1",
    804: "1",
    805: "1",
    806: "1",
    807: "1",
    808: "1",
    809: "1",
    810: "1",
    811: "1",
    812: "1",
    813: "1",
    814: "1",
    815: "1",
    816: "1",
  });
  const [filtredurumselectValue, setfiltreselectSelectValue] = useState({
    801: "TEMİZ",
    802: "TEMİZ",
    803: "TEMİZ",
    804: "TEMİZ",
    805: "TEMİZ",
    806: "TEMİZ",
    807: "TEMİZ",
    808: "TEMİZ",
    809: "TEMİZ",
    810: "TEMİZ",
    811: "TEMİZ",
    812: "TEMİZ",
    813: "TEMİZ",
    814: "TEMİZ",
    815: "TEMİZ",
    816: "TEMİZ",
  });
  const [arızadurumselectValue, setarızadurumSelectValue] = useState("NORMAL");
  const [arızakoduselectValue, setarızakoduSelectValue] = useState("0");

  const FanModuSelectChange = (event) => {
    setfanmoduSelectValue(event.target.value);
  };
  const FiltreDurumSelectChange = (event) => {
    setfiltreselectSelectValue(event.target.value);
  };
  const ArızaDurumSelectChange = (event) => {
    setarızadurumSelectValue(event.target.value);
  };
  const ArızaKoduSelectChange = (event) => {
    const selectedArızaKodu = event.target.value;
    setarızakoduSelectValue(selectedArızaKodu);

    if (selectedArızaKodu === "0") {
      setarızadurumSelectValue("NORMAL");
    } else if (selectedArızaKodu === "1") {
      setarızadurumSelectValue("ALARM");
    }
  };

  const initialOdaSetDegerler = {
    801: "25",
    802: "25",
    803: "25",
    804: "25",
    805: "25",
    806: "25",
    807: "25",
    808: "25",
    809: "25",
    810: "25",
    811: "25",
    812: "25",
    813: "25",
    814: "25",
    815: "25",
    816: "25",
  };

  const [lock, Setlock] = useState({
    801: "0",
    802: "0",
    803: "0",
    804: "0",
    805: "0",
    806: "0",
    807: "0",
    808: "0",
    809: "0",
    810: "0",
    811: "0",
    812: "0",
    813: "0",
    814: "0",
    815: "0",
    816: "0",
  });
  const [lock2, Setlock2] = useState({
    801: "0",
    802: "0",
    803: "0",
    804: "0",
    805: "0",
    806: "0",
    807: "0",
    808: "0",
    809: "0",
    810: "0",
    811: "0",
    812: "0",
    813: "0",
    814: "0",
    815: "0",
    816: "0",
  });
  const [lock3, Setlock3] = useState({
    801: "0",
    802: "0",
    803: "0",
    804: "0",
    805: "0",
    806: "0",
    807: "0",
    808: "0",
    809: "0",
    810: "0",
    811: "0",
    812: "0",
    813: "0",
    814: "0",
    815: "0",
    816: "0",
  });

  const initialSogutmamoduSet = {
    801: "19",
    802: "19",
  };
  const initialSogutmamoduUst = {
    801: "22",
    802: "22",
  };
  const initialSogutmamoduAlt = {
    801: "18",
    802: "18",
  };
  const initialIsıtmamoduSet = {
    801: "28",
    802: "28",
  };
  const initialIsıtmamoduUst = {
    801: "30",
    802: "30",
  };
  const initialIsıtmamoduAlt = {
    801: "26",
    802: "26",
  };

  const sendSetValueFunc = async (list_) => {
    try {
      console.log("sendSetValueFunc çağrıldı", list_);

      // API çağrısını yap
      const req = await axiosInstance.post(
        "https://app-rmmscmdapi.azurewebsites.net/api/cmd/SetValue",
        list_
      );

      // API yanıtını işle
      const response = req.data;
      console.log("API yanıtı:", response);

      {
        console.log("API çağrısı başarılı, verileri güncelleniyor.");

        // Tag değerlerini al
        var obj__ = [];
        var obj2__ = [];

        initalState.forEach((item) => {
          Object.entries(item).forEach((a) => {
            obj__.push(a[1]);
          });
        });

        obj__.forEach((item2) => {
          item2.forEach((item3) => {
            obj2__.push({ tagId: item3.tagId });
            // tagId2 varsa onu da ekleyelim
            if (item3.tagId2) {
              obj2__.push({ tagId: item3.tagId2 });
            }else if(item3.device)               obj2__.push({ tagId: item3.device });
          });
        });

        console.log("Tag ID'leri:", obj2__);

        // Tag değerlerini al ve güncelle
        const fetch_tag_values = async () => {
          if (window.location.pathname === "/vrfhacim") {
            try {
              const request = await axiosInstance.post(
                "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
                obj2__
              );
              const response = request.data;

              // Gelen yanıtın içerisinde tagId2'leri bulup ekliyoruz
              const updatedResponse = response.map((item) => {
                const matchedItem = obj2__.find(
                  (objItem) => objItem.tagId === item.tagId
                );
                return {
                  ...item,
                  tagId2: matchedItem ? matchedItem.tagId : null,
                };
              });

              console.log("Tag değerleri alındı:", response);

              Store.dispatch(set_vrfhacim_tags(response));
            } catch (err) {
              console.log("Tag değerleri fetch hatası:", err);
            } finally {
              Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
            }
          }
        };

        await fetch_tag_values();
      }
    } catch (error) {
      console.log("sendSetValueFunc hatası:", error);
    }
  };

  // const fakeSendSetValueFunc = async (list_) => {
  //
  //   try {
  //     console.log("fakeSendSetValueFunc çağrıldı", list_);

  //     // Fake API yanıtını simüle et
  //     const fakeApiResponse = {
  //       status: 200,
  //       json: async () => ({
  //         success: true,
  //         message: "Fake API çağrısı başarılı!",
  //         data: list_,
  //       }),
  //     };

  //     // API yanıtını işleyelim
  //     const response = await fakeApiResponse.json();
  //     console.log("Fake API yanıtı:", response);
  //     console.log("HTTP durum kodu:", fakeApiResponse.status);

  //     if (fakeApiResponse.status === 200) {
  //       console.log("Fake API çağrısı başarılı, veriler güncelleniyor.");

  //       // Tag değerlerini al
  //       var obj__ = [];
  //       var obj2__ = [];

  //       initalState.forEach((item) => {
  //         Object.entries(item).forEach((a) => {
  //           obj__.push(a[1]);
  //         });
  //       });

  //       obj__.forEach((item2) => {
  //         item2.forEach((item3) => {
  //           obj2__.push({ tagId: item3.tagId });
  //           // tagId2 varsa onu da ekleyelim
  //           if (item3.tagId2) {
  //             obj2__.push({ tagId: item3.tagId2 });
  //           }
  //         });
  //       });

  //       console.log("Tag ID'leri:", obj2__);

  //       // Fake tag değerlerini al ve güncelle
  //       const fakeFetchTagValues = async () => {
  //         if (window.location.pathname === "/vrfhacim") {
  //           try {
  //             const fakeTagResponse = obj2__.map((tag) => ({
  //               tagId: tag.tagId,
  //               value: Math.random() * 100, // Rastgele bir değer döndür
  //             }));

  //             const updatedResponse = fakeTagResponse.map((item) => {
  //               const matchedItem = obj2__.find(
  //                 (objItem) => objItem.tagId === item.tagId
  //               );
  //               return {
  //                 ...item,
  //                 tagId2: matchedItem ? matchedItem.tagId : null,
  //               };
  //             });

  //             console.log("Fake tag değerleri alındı:", updatedResponse);

  //             Store.dispatch(set_vrfhacim_tags(updatedResponse));
  //           } catch (err) {
  //             console.log("Fake tag değerleri fetch hatası:", err);
  //           } finally {
  //             Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
  //           }
  //         }
  //       };

  //       await fakeFetchTagValues();
  //     } else {
  //       console.log("Fake API çağrısı başarısız:", fakeApiResponse.status);
  //     }
  //   } catch (error) {
  //     console.log("fakeSendSetValueFunc hatası:", error);
  //   }
  // };

  const handleOdaSetDegeriDone = (roomNumber) => {
    const updatedValue = String(odasetdegerler[roomNumber]);
    let tagId;

    state.forEach((item) => {
      if (item[String(roomNumber)]) {
        tagId = item[String(roomNumber)].find(
          (x) => x.text === "Oda Set Değeri"
        )?.tagId;
      }
    });

    if (tagId) {
      sendSetValueFunc({
        TagId: String(tagId),
        TagValue: updatedValue,
      });
    }
  };

  const [odasetdegerler, setOdasetdegerler] = useState(initialOdaSetDegerler);
  const [initialOdasetdegerler, setInitialOdasetdegerler] = useState(
    initialOdaSetDegerler
  );
  const [sogutmamoduSet, SetsogutmamoduSet] = useState(initialSogutmamoduSet);
  const [initialSogutmaModuSet, setInitialSogutmamoduSet] = useState(
    initialSogutmamoduSet
  );
  const [sogutmamoduUst, SetsogutmamoduUst] = useState(initialSogutmamoduUst);
  const [initialSogutmaModuUst, setInitialSogutmamoduUst] = useState(
    initialSogutmamoduUst
  );
  const [sogutmamoduAlt, SetsogutmamoduAlt] = useState(initialSogutmamoduAlt);
  const [initialSogutmaModuAlt, setInitialSogutmamoduAlt] = useState(
    initialSogutmamoduAlt
  );
  const [ısıtmamoduSet, SetısıtmamoduSet] = useState(initialIsıtmamoduSet);
  const [initialIsıtmaModuSet, setInitialIsıtmamoduSet] =
    useState(initialIsıtmamoduSet);
  const [ısıtmamoduUst, SetısıtmamoduUst] = useState(initialIsıtmamoduUst);
  const [initialIsıtmaModuUst, setInitialIsıtmamoduUst] =
    useState(initialIsıtmamoduUst);
  const [ısıtmamoduAlt, SetısıtmamoduAlt] = useState(initialIsıtmamoduAlt);
  const [initialIsıtmaModuAlt, setInitialIsıtmamoduAlt] =
    useState(initialIsıtmamoduAlt);

  const [active_rm2, Set_active_rm2] = useState(false); // render modal 2

  const [setDegerleri, SETSetDegerleri] = useState(false);

  useEffect(() => {
    if (props.vrfhacim_tags.length > 0) {
      console.log(props.vrfhacim_tags);

      const inital_func = () => {
        var obj__ = [];
        var obj2__ = [];

        initalState.forEach((item) => {
          Object.entries(item).forEach((a) => {
            obj__.push(a[1]);
          });
        });

        obj__.forEach((item2) => {
          item2.forEach((item3) => {
            obj2__.push({ tagId: item3.tagId });
            // tagId2 varsa onu da ekleyelim
            if (item3.tagId2) {
              obj2__.push({ tagId: item3.tagId2 });
            }else if(item3.device)               obj2__.push({ tagId: item3.device });
          });
        });

        const fetch_tag_values = async () => {
          if (window.location.pathname === "/vrfhacim") {
            try {
              const request = await axiosInstance.post(
                "https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues",
                obj2__
              );
              const response = request.data;

              // Gelen yanıtın içerisinde tagId2'leri bulup ekliyoruz
              const updatedResponse = response.map((item) => {
                const matchedItem = obj2__.find(
                  (objItem) => objItem.tagId === item.tagId
                );
                return {
                  ...item,
                  tagId2: matchedItem ? matchedItem.tagId : null,
                };
              });

              Store.dispatch(set_vrfhacim_tags(updatedResponse));
              Set_render_state(updatedResponse);
            } catch (err) {
              console.log(err);
            } finally {
              Store.dispatch(SET_FETCH_TAG_VALUE_CONTROL(false));
            }
          }
        };
        fetch_tag_values();
      };

      inital_func();

      var title = [];
      var title2 = [];
      var title3 = [];
      var title4 = [];

      var tag_values_set = [];
      var tag_values_set2 = [];
      var tag_values_set3 = [];
      var tag_values_calisma = [];
      var tag_values_cihaz = [];
      var tag_values_fan = [];
      var tag_values_led = [];
      var tag_values_filtre = [];
      var tag_lock = [];
      var tag_lock2 = [];
      var tag_lock3 = [];

      var newdata = [];
      var newdata2 = [];
      var newdata3 = [];

      state.map((item, index) => {
        var obj_ = [];
        Object.entries(item).forEach((a) => {
          title.push(a[0]);
          title2.push(a[0]);
          title3.push(a[0]);
          title4.push(a[0]);

          obj_.push(a[1]);
        });
        obj_[0].forEach((item_) => {
          console.log(item_);
          props.vrfhacim_tags.forEach((item2) => {
            if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Oda Set Değeri"
            ) {
              console.log(item2.tagValue);
              tag_values_set.push(item2.tagValue);
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Soğutma Modu Set Değeri"
            ) {
              tag_values_set2.push(item2.tagValue);
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Isıtma Modu Set Değeri"
            ) {
              tag_values_set3.push(item2.tagValue);
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Çalışma Modu"
            ) {
              console.log(item2.tagValue);
              tag_values_calisma.push(
                item2.tagValue.trim() === "2"
                  ? "ISITMA"
                  : item2.tagValue.trim() === "1"
                  ? "SOĞUTMA"
                  : item2.tagValue.trim() === "5"
                  ? "NEM ALMA"
                  : item2.tagValue.trim() === "3"
                  ? "FAN"
                  : "AUTO"
              );
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Cihaz"
            ) {
              tag_values_cihaz.push(
                item2.tagValue.trim() === "0" ? "OFF" : "ON"
              );
              tag_values_led.push(
                item2.tagValue.trim() === "0" ? "gray" : "green"
              );
            } else if (
              item_.device === String(item2.tagId) &&
              item_.text === "Cihaz"
            ) {
              tag_lock.push(item2.tagValue);
            } else if (
              item_.device === String(item2.tagId) &&
              item_.text === "Çalışma Modu"
            ) {
              tag_lock2.push(item2.tagValue);
            } else if (
              item_.device === String(item2.tagId) &&
              item_.text === "Oda Set Değeri"
            ) {
              tag_lock3.push(item2.tagValue);
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Fan Modu"
            ) {
              const valueMapping = {
                1: "DÜŞÜK",
                2: "HIZLI",
                3: "ORTA 2",
                4: "ORTA",
                5: "AUTO",
              };

              tag_values_fan.push(
                valueMapping[item2.tagValue.trim()] || item2.tagValue.trim()
              );
            } else if (
              item_.tagId === String(item2.tagId) &&
              item_.text === "Filtre Durumu"
            ) {
              console.log(item2.tagValue);
              //
              tag_values_filtre.push(
                item2.tagValue.trim() === "1" ? "TEMİZ" : "KİRLİ"
              );
            }
          });
        });
      });

      console.log(tag_values_set);

      var obj2_2 = {
        801: "ISITMA",
        802: "ISITMA",
        803: "ISITMA",
        804: "ISITMA",
        805: "ISITMA",
        806: "ISITMA",
        807: "ISITMA",
        808: "ISITMA",
        809: "ISITMA",
        810: "ISITMA",
        811: "ISITMA",
        812: "ISITMA",
        813: "ISITMA",
        814: "ISITMA",
        815: "ISITMA",
        816: "ISITMA",
      };

      var obj2_7 = {
        801: "TEMİZ",
        802: "TEMİZ",
        803: "TEMİZ",
        804: "TEMİZ",
        805: "TEMİZ",
        806: "TEMİZ",
        807: "TEMİZ",
        808: "TEMİZ",
        809: "TEMİZ",
        810: "TEMİZ",
        811: "TEMİZ",
        812: "TEMİZ",
        813: "TEMİZ",
        814: "TEMİZ",
        815: "TEMİZ",
        816: "TEMİZ",
      };

      var obj2_3 = {
        801: "ON",
        802: "ON",
        803: "ON",
        804: "ON",
        805: "ON",
        806: "ON",
        807: "ON",
        808: "ON",
        809: "ON",
        810: "ON",
        811: "ON",
        812: "ON",
        813: "ON",
        814: "ON",
        815: "ON",
        816: "ON",
      };

      var obj2_lock = {
        801: "0",
        802: "0",
        803: "0",
        804: "0",
        805: "0",
        806: "0",
        807: "0",
        808: "0",
        809: "0",
        810: "0",
        811: "0",
        812: "0",
        813: "0",
        814: "0",
        815: "0",
        816: "0",
      };

      var obj2_lock3 = {
        801: "0",
        802: "0",
        803: "0",
        804: "0",
        805: "0",
        806: "0",
        807: "0",
        808: "0",
        809: "0",
        810: "0",
        811: "0",
        812: "0",
        813: "0",
        814: "0",
        815: "0",
        816: "0",
      };
      var obj2_lock2 = {
        801: "0",
        802: "0",
        803: "0",
        804: "0",
        805: "0",
        806: "0",
        807: "0",
        808: "0",
        809: "0",
        810: "0",
        811: "0",
        812: "0",
        813: "0",
        814: "0",
        815: "0",
        816: "0",
      };

      var obj2_4 = {
        801: "1 ",
        802: "1 ",
        803: "1 ",
        804: "1 ",
        805: "1 ",
        806: "1 ",
        807: "1 ",
        808: "1 ",
        809: "1 ",
        810: "1 ",
        811: "1 ",
        812: "1 ",
        813: "1 ",
        814: "1 ",
        815: "1 ",
        816: "1 ",
      };

      var obj2_5 = {
        801: "green",
        802: "green",
        803: "green",
        804: "green",
        805: "green",
        806: "green",
        807: "green",
        808: "green",
        809: "green",
        810: "green",
        811: "green",
        812: "green",
        813: "green",
        814: "green",
        815: "green",
        816: "green",
      };

      console.log(obj2_2);
      //

      console.log(title, title2, title3, tag_values_calisma);
      for (let i = 0; i < title.length; i++) {
        newdata[title[i]] = tag_values_set[i].trim();
      }
      for (let i = 0; i < title2.length; i++) {
        newdata2[title2[i]] = tag_values_set2[i];
      }
      for (let i = 0; i < title3.length; i++) {
        newdata3[title3[i]] = tag_values_set3[i];
      }

      for (let k = 0; k < 13; k++) {
        obj2_2[String(k + 801)] = tag_values_calisma[k];
      }
      for (let k = 0; k < 13; k++) {
        obj2_3[String(k + 801)] = tag_values_cihaz[k];
      }
      for (let k = 0; k < 13; k++) {
        obj2_4[String(k + 801)] = tag_values_fan[k];
      }
      for (let k = 0; k < 13; k++) {
        obj2_5[String(k + 801)] = tag_values_led[k];
      }
      for (let k = 0; k < 13; k++) {
        obj2_7[String(k + 801)] = tag_values_filtre[k];
      }

      for (let k = 0; k < 13; k++) {
        obj2_lock[String(k + 801)] = tag_lock[k];
      }
      for (let k = 0; k < 13; k++) {
        obj2_lock2[String(k + 801)] = tag_lock2[k];
      }
      for (let k = 0; k < 13; k++) {
        obj2_lock3[String(k + 801)] = tag_lock3[k];
      }
      setOdasetdegerler(newdata);
      SetsogutmamoduSet(newdata2);
      SetısıtmamoduSet(newdata3);

      console.log(obj2_2);

      Setcihazled(obj2_5);
      Setlock(obj2_lock);
      Setlock2(obj2_lock2);
      Setlock3(obj2_lock3);

      setcihazSelectValue(obj2_3);
      setcalismamoduSelectValue(obj2_2);
      setfanmoduSelectValue(obj2_4);
      setfiltreselectSelectValue(obj2_7);
    }
  }, []);

  const year_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastYear = new Date(today);
      lastYear.setFullYear(today.getFullYear() - 1);

      let todayFormatted = formatDate(today);
      let lastYearFormatted = formatDate(lastYear);

      let newObj = {
        inital_date: lastYearFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.error(err);
    }
  };

  const handleInputChange = (roomNumber, type) => (event) => {
    const newValue =
      event.target.value === ""
        ? ""
        : Math.max(18, Math.min(30, Number(event.target.value)));

    switch (type) {
      case "odasetdeger":
        setOdasetdegerler((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "sogutmamoduSet":
        SetsogutmamoduSet((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "sogutmamoduUst":
        SetsogutmamoduUst((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "sogutmamoduAlt":
        SetsogutmamoduAlt((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "ısıtmamoduSet":
        SetısıtmamoduSet((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "ısıtmamoduUst":
        SetısıtmamoduUst((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;
      case "ısıtmamoduAlt":
        SetısıtmamoduAlt((prevValues) => ({
          ...prevValues,
          [roomNumber]: String(newValue),
        }));
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    setInitialOdasetdegerler(odasetdegerler);
    setInitialSogutmamoduSet(sogutmamoduSet);
    setInitialSogutmamoduUst(sogutmamoduUst);
    setInitialSogutmamoduAlt(sogutmamoduAlt);
    setInitialIsıtmamoduSet(ısıtmamoduSet);
    setInitialIsıtmamoduUst(ısıtmamoduUst);
    setInitialIsıtmamoduAlt(ısıtmamoduAlt);
  }, []);

  useEffect(() => {
    console.log("VRFHacim TAGS = ", props.vrfhacim_tags);
  }, [props.vrfhacim_tags]);

  const [isEditing1, setIsEditing1] = useState(false);
  const [isEditing2, setIsEditing2] = useState(false);
  const [isEditing3, setIsEditing3] = useState(false);
  const [isEditing4, setIsEditing4] = useState(false);
  const [isEditing5, setIsEditing5] = useState(false);
  const [isEditing6, setIsEditing6] = useState(false);

  const handleEditStart1 = () => {
    setIsEditing1(true);
  };
  const handleEditStart2 = () => {
    setIsEditing2(true);
  };
  const handleEditStart3 = () => {
    setIsEditing3(true);
  };
  const handleEditStart4 = () => {
    setIsEditing4(true);
  };
  const handleEditStart5 = () => {
    setIsEditing5(true);
  };
  const handleEditStart6 = () => {
    setIsEditing6(true);
  };

  const handleEditCancel1 = () => {
    setIsEditing1(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone1 = () => {
    setIsEditing1(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel2 = () => {
    setIsEditing2(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone2 = () => {
    setIsEditing2(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel3 = () => {
    setIsEditing3(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone3 = () => {
    setIsEditing3(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel4 = () => {
    setIsEditing4(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone4 = () => {
    setIsEditing4(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel5 = () => {
    setIsEditing5(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone5 = () => {
    setIsEditing5(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };
  const handleEditCancel6 = () => {
    setIsEditing6(false);
    // İptal durumunda orijinal değeri geri yükleyebilirsiniz
  };

  const handleEditDone6 = () => {
    setIsEditing6(false);
    // Değerin kaydedilmesi veya diğer işlemleri buraya ekleyebilirsiniz
  };

  const [active, Set_active] = useState(false);

  const [changed_values, Set_changed_values] = useState([]);
  const [changed_values2, Set_changed_values2] = useState([]);

  useEffect(() => {
    setInitialOdasetdegerler(odasetdegerler);
    setInitialSogutmamoduSet(sogutmamoduSet);
    setInitialSogutmamoduUst(sogutmamoduUst);
    setInitialSogutmamoduAlt(sogutmamoduAlt);
    setInitialIsıtmamoduSet(ısıtmamoduSet);
    setInitialIsıtmamoduUst(ısıtmamoduUst);
    setInitialIsıtmamoduAlt(ısıtmamoduAlt);
    setTimeout(() => {
      Set_changed_values([]);
      Set_changed_values2([]);
    }, 3000);
  }, []);

  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Isıtma" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Isıtma"]);
    }
  }, [ısıtmamoduSet]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Soğutma" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Soğutma"]);
    }
  }, [sogutmamoduSet]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("SET" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "SET"]);
    }
  }, [odasetdegerler]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Çalışma" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Çalışma"]);
    }
  }, [calismamoduselectValue]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Fan" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Fan"]);
    }
  }, [fanmoduselectValue]);
  useEffect(() => {
    let newdata = changed_values;
    var toplam_ = 0;
    for (let i of newdata) {
      if ("Cihaz" === i) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values((Prevvalues) => [...Prevvalues, "Cihaz"]);
    }
  }, [cihazselectValue]);

  const genel_value_changes = (type, value) => {
    let newdata = changed_values2;
    var toplam_ = 0;
    for (let i of newdata) {
      if (type === i.type) {
        toplam_++;
      }
    }
    if (toplam_ < 1) {
      Set_changed_values2((Prevvalues) => [
        ...Prevvalues,
        { type: type, value: value },
      ]);
    }
  };

  const renderModalContent = (roomNumber) => {
    const roomLabel = roomNames[roomNumber];
    return (
      <div className={classes.paper + " vrf-popup-kapsayici"}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => {
            handleClose(roomNumber);
            SETSetDegerleri(false);
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="h2"
          style={{
            color: "rgb(28,28,28)",
            textAlign: "center",
          }}
          gutterBottom
          id="oda-pop-up-baslik"
        >
          {`${roomLabel} `}
        </Typography>
        <div className="vrf-popup-select">
          {state.map((item, index) => {
            var title = [];
            var obj_ = [];
            Object.entries(item).forEach((a) => {
              if (a[0] === String(roomNumber)) {
                title.push(a[0]);
                obj_.push(a[1]);
              }
            });
            if (title.length > 0 && obj_.length > 0) {
              return (
                <div style={{ width: "100%", marginRight: "16px" }}>
                  {obj_[0].map((x, index) => {
                    switch (x.text) {
                      case "Oda Sıcaklığı":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {x.text.toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <Select
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;

                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  let newX = clientX;
                                  let newY = clientY;

                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                labelId={`oda${roomNumber}-oda-sicakligi-label`}
                                id={`oda${roomNumber}-oda-sicakligi-select`}
                                displayEmpty
                                IconComponent={() => null}
                                disabled={!vrf_okuma_control}
                              >
                                <MenuItem>
                                  <span
                                    style={{
                                      display: "flex",
                                      width: "83%",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <em
                                      style={{ flex: 1, textAlign: "center" }}
                                    >
                                      {değerler_eleman}
                                    </em>
                                    <span
                                      style={{
                                        position: "relative",
                                        right: "7%",
                                        color: "rgba(0, 0, 0, 0.54)",
                                        fontSize: "1rem",
                                        fontWeight: 400,
                                      }}
                                    >
                                      °C
                                    </span>
                                  </span>
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        );

                      case "Oda Set Değeri":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        return (
                          <div
                            className={classes.statusRow}
                            id="vrf_pop_up_row"
                          >
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {x.text.toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{ minWidth: "120px" }}
                            >
                              <Input
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                labelId={`oda${roomNumber}-oda-set-degeri-label`}
                                className="oda-set-degeri-padding"
                                id={`oda${roomNumber}-oda-set-degeri-input`}
                                sx={{ fontWeight: 600 }}
                                type="number"
                                disabled={
                                  locked[roomNumber]?.odasetdegeri ||
                                  !vrf_okuma_control
                                }
                                value={odasetdegerler[roomNumber]}
                                onChange={(e) => {
                                  Set_active(true);
                                  SETSetDegerleri(true);

                                  handleInputChange(
                                    roomNumber,
                                    "odasetdeger"
                                  )(e);
                                }}
                                endAdornment={
                                  <InputAdornment
                                    className="vrf-derece"
                                    position="end"
                                  >
                                    °C
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <IconButton
                              onClick={() => {
                                let tagId_;
                                state.forEach((a) => {
                                  if (
                                    a[String(active_room_number)] !== undefined
                                  ) {
                                    tagId_ =
                                      a[String(active_room_number)][1].device;
                                  }
                                });
                                let value = String(
                                  lock3[active_room_number] === "0" ? "1" : "0"
                                );

                                sendSetValueFunc({
                                  TagId: String(tagId_),
                                  TagValue: value,
                                });

                                Setlock3((prevValues) => ({
                                  ...prevValues,
                                  [roomNumber]: value,
                                }));
                                toggleLock(roomNumber, "device");
                              }}
                              className={classes.lockButton}
                            >
                              {lock3[roomNumber] === "0" ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      case "Cihaz":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = String(Math.round(Number(değerler[0])));

                        var cihazDurumuText =
                          değerler_eleman === "0" ? "OFF" : "ON"; // Varsayılan ON olur

                        // tagId2 ve işlenmiş değerleri yazdır
                        console.log(
                          `TagId: ${x.tagId}, Değer: ${değerler_eleman}, Mod: ${cihazDurumuText} CİHAZZZZZZ`
                        );

                        var cihazRengi =
                          değerler_eleman === "0" ? "gray" : "green";

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              CİHAZ
                            </Typography>
                            <div
                              className="deviceStatusIndicator"
                              style={{
                                backgroundColor:
                                  cihazRengi || cihazled[String(roomNumber)],
                              }}
                            ></div>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.device}
                            >
                              <div
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                onClick={(e) => {
                                  if (!locked[roomNumber]?.device) {
                                    e.target.nextElementSibling.classList.toggle(
                                      "cihaz_modu_menu_active"
                                    );
                                  }
                                }}
                                id="cihaz_modu_div"
                                className="cihaz_modu_div"
                                style={{
                                  color:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "2px solid #edbc45"
                                      : "2px solid #edbc45",
                                  pointerEvents:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                              >
                                {cihazDurumuText ||
                                  cihazselectValue[String(roomNumber)]}
                              </div>
                              {locked[roomNumber]?.device || (
                                <ul className="cihaz_modu_menu">
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = cihazselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcihazSelectValue((prevValues) => ({
                                        ...prevValues,
                                        [roomNumber]: textCurrent,
                                      }));

                                      Setcihazled((prevCihazled) => ({
                                        ...prevCihazled,
                                        [String(roomNumber)]: "green",
                                      }));

                                      e.target.parentElement.classList.toggle(
                                        "cihaz_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                      document.querySelector(
                                        ".deviceStatusIndicator"
                                      ).style.backgroundColor = "green";
                                    }}
                                  >
                                    ON
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = cihazselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcihazSelectValue((prevValues) => ({
                                        ...prevValues,
                                        [roomNumber]: textCurrent,
                                      }));

                                      Setcihazled((prevCihazled) => ({
                                        ...prevCihazled,
                                        [String(roomNumber)]: "gray",
                                      }));
                                      e.target.parentElement.classList.toggle(
                                        "cihaz_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                      document.querySelector(
                                        ".deviceStatusIndicator"
                                      ).style.backgroundColor = "gray";
                                    }}
                                  >
                                    OFF
                                  </li>
                                </ul>
                              )}
                            </FormControl>
                            <IconButton
                              onClick={() => {
                                let tagId_;
                                state.forEach((a) => {
                                  if (
                                    a[String(active_room_number)] !== undefined
                                  ) {
                                    tagId_ =
                                      a[String(active_room_number)][2].device;
                                  }
                                });
                                let value = String(
                                  lock[active_room_number] === "0" ? "1" : "0"
                                );

                                sendSetValueFunc({
                                  TagId: String(tagId_),
                                  TagValue: value,
                                });

                                Setlock((prevValues) => ({
                                  ...prevValues,
                                  [roomNumber]: value,
                                }));
                                toggleLock(roomNumber, "device");
                              }}
                              className={classes.lockButton}
                            >
                              {lock[roomNumber] === "0" ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      // Çalışma Modu
                      case "Çalışma Modu":
                        // tagId2'lerin listesini tanımla
                        var tagId2ler = [
                          "2857",
                          "2860",
                          "2863",
                          "2866",
                          "2869",
                          "2872",
                          "2875",
                          "2878",

                          "2884",
                          "2887",
                          "2890",
                          "2893",
                        ];

                        // Eğer x.tagId2 tagId2ler listesinde varsa, render_state'ten filtrele
                        if (tagId2ler.includes(String(x.tagId2))) {
                          var değerler = render_state
                            .filter((a) => String(a.tagId) === String(x.tagId))
                            .map((b) => b.tagValue);

                          var değerler_eleman = String(Math.round(Number(değerler[0])));

                          // tagValue değerini işleme alıyoruz
                          var calismaModuText =
                            değerler_eleman === "2"
                              ? "ISITMA"
                              : değerler_eleman === "1"
                              ? "SOĞUTMA"
                              : değerler_eleman === "5"
                              ? "NEM ALMA"
                              : değerler_eleman === "3"
                              ? "FAN"
                              : "AUTO"; // Varsayılan AUTO olur

                          // tagId2 ve işlenmiş değerleri yazdır
                          console.log(
                            `TagId2: ${x.tagId2}, Değer: ${değerler_eleman}, Mod: ${calismaModuText}`
                          );
                        } else {
                          console.log(
                            `TagId2: ${x.tagId2}, eşleşen tagId bulunamadı`
                          );
                        }

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              ÇALIŞMA MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.mode}
                            >
                              <div
                                style={{
                                  color:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "2px solid #edbc45"
                                      : "2px solid #edbc45",
                                  pointerEvents:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                                onClick={(e) => {
                                  if (!locked[roomNumber]?.mode) {
                                    e.target.nextElementSibling.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                  }
                                }}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId2)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId2;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  let newX = clientX;
                                  let newY = clientY;

                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                id="calisma_modu_div"
                                className="calisma_modu_div"
                              >
                                {calismaModuText ||
                                  calismamoduselectValue[String(roomNumber)]}
                              </div>
                              {locked[roomNumber]?.mode || (
                                <ul className="calisma_modu_menu">
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    ISITMA
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    SOĞUTMA
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    NEM ALMA
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    AUTO
                                  </li>
                                  <li
                                    onClick={(e) => {
                                      SETSetDegerleri(true);

                                      var textCurrent = e.target.textContent;
                                      var newObj = calismamoduselectValue;
                                      newObj[roomNumber] = textCurrent;

                                      setcalismamoduSelectValue(
                                        (prevValues) => ({
                                          ...prevValues,
                                          [roomNumber]: textCurrent,
                                        })
                                      );

                                      e.target.parentElement.classList.toggle(
                                        "calisma_modu_menu_active"
                                      );
                                      e.target.parentElement.previousElementSibling.innerHTML =
                                        textCurrent;
                                    }}
                                  >
                                    FAN
                                  </li>
                                </ul>
                              )}
                            </FormControl>
                            <IconButton
                              onClick={() => {
                                let tagId_;
                                state.forEach((a) => {
                                  if (
                                    a[String(active_room_number)] !== undefined
                                  ) {
                                    tagId_ =
                                      a[String(active_room_number)][3].device;
                                  }
                                });
                                let value = String(
                                  lock2[active_room_number] === "0" ? "1" : "0"
                                );

                                sendSetValueFunc({
                                  TagId: String(tagId_),
                                  TagValue: value,
                                });

                                Setlock2((prevValues) => ({
                                  ...prevValues,
                                  [roomNumber]: value,
                                }));
                                toggleLock(roomNumber, "device");
                              }}
                              className={classes.lockButton}
                            >
                              {lock2[roomNumber] === "0" ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      // Çalışma Durumu
                      case "Çalışma Durumu":
                        // Filtrelenmiş tagId ve tagValue'leri al
                        var çalışmaModuDeğerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);

                        // İlk elemanı al
                        var çalışmaModuEleman = String(Math.round(Number(çalışmaModuDeğerler[0])));

                        // TagId ve değerleri konsola yazdır
                        console.log(
                          `TagId: ${x.tagId}, Değer: ${çalışmaModuEleman}`
                        );

                        // Rengi belirle
                        var çalışmaDurumuRengi =
                          çalışmaModuEleman === "1"
                            ? "cornflowerblue"
                            : çalışmaModuEleman === "2"
                            ? "red"
                            : "gray";

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              ÇALIŞMA DURUMU
                            </Typography>
                            <div
                              style={{
                                backgroundColor: çalışmaDurumuRengi,
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                position: "absolute",
                                left: "65%",
                              }}
                            ></div>
                          </div>
                        );

                      case "Fan Modu":
                        var tagId2ler = [
                          "2858",
                          "2861",
                          "2864",
                          "2867",
                          "2870",
                          "2873",
                          "2876",
                          "2879",
                          "2881",
                          "2885",
                          "2888",
                          "2891",
                          "2894",
                        ];

                        // Eğer x.tagId2 tagId2ler listesinde varsa, render_state'ten filtrele
                        if (tagId2ler.includes(String(x.tagId2))) {
                          var değerler = render_state
                            .filter((a) => String(a.tagId) === String(x.tagId))
                            .map((b) => b.tagValue);

                          var değerler_eleman = değerler[0]; // Trimleme burada yapılıyor

                          var fanModuText =
                            değerler_eleman === "1 "
                              ? "DÜŞÜK"
                              : değerler_eleman === "2 "
                              ? "HIZLI"
                              : değerler_eleman === "3 "
                              ? "ORTA 2"
                              : değerler_eleman === "4 "
                              ? "ORTA"
                              : "AUTO"; // Varsayılan AUTO olur

                          console.log(
                            `TagId2: ${x.tagId2}, Değer: ${değerler_eleman}, Mod: ${fanModuText} FANNNN`
                          );
                        } else {
                          console.log(
                            `TagId2: ${x.tagId2}, eşleşen tagId bulunamadı`
                          );
                        }
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              FAN MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <div
                                style={{
                                  borderRadius: "4px",
                                  color: !vrf_okuma_control ? "gray" : "",
                                  border: !vrf_okuma_control
                                    ? "2px solid #edbc45"
                                    : "2px solid #edbc45",
                                  pointerEvents: !vrf_okuma_control
                                    ? "none"
                                    : "all",
                                }}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "fan_modu_menu_active"
                                  );
                                }}
                                id="fan_modu_div"
                                className="fan_modu_div"
                              >
                                {fanModuText ||
                                  fanmoduselectValue[String(roomNumber)]}
                              </div>
                              <ul className="fan_modu_menu">
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  DÜŞÜK
                                </li>

                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA
                                </li>
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA 2
                                </li>
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  HIZLI
                                </li>
                                <li
                                  onClick={(e) => {
                                    SETSetDegerleri(true);

                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    setfanmoduSelectValue((prevValues) => ({
                                      ...prevValues,
                                      [roomNumber]: textCurrent,
                                    }));
                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  AUTO{" "}
                                </li>
                              </ul>
                            </FormControl>
                            <IconButton
                              onClick={() =>
                                toggleLock(roomNumber, "odasetdegeri")
                              }
                              className={classes.lockButton}
                              style={{
                                opacity: "0",
                                position: "relative",
                                zIndex: "-1000000",
                                transform:
                                  initialOdasetdegerler[roomNumber] !==
                                  odasetdegerler[roomNumber]
                                    ? "scale(0.7)"
                                    : "scale(1)",
                              }}
                            >
                              {locked[roomNumber]?.odasetdegeri ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      // case "Filtre Durumu":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(x.tagId))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];

                      //   değerler_eleman =
                      //     değerler_eleman === "1 " ? "TEMİZ" : "KİRLİ";

                      //   değerler_eleman =
                      //     değerler_eleman === "1 " ? "TEMİZ" : "KİRLİ";

                      //   return (
                      //     <div className={classes.statusRow}>
                      //       <Typography
                      //         variant="subtitle1"
                      //         className={classes.statusLabel}
                      //       >
                      //         {x.text.toUpperCase()}
                      //       </Typography>
                      //       <FormControl
                      //         variant="outlined"
                      //         className={classes.formControl}
                      //       >
                      //         <Select
                      //           disabled={!vrf_okuma_control}
                      //           onContextMenu={(e) => {
                      //             e.preventDefault();
                      //             const { clientX, clientY } = e;
                      //             var tagName = props.tag_list
                      //               .filter((b) => b.tagId === x.tagId)
                      //               .map((c) => c.tagName)[0];
                      //             document.querySelector(
                      //               ".show_tagName"
                      //             ).innerHTML = tagName;
                      //             document
                      //               .querySelector(".show_external_trend")
                      //               .classList.toggle(
                      //                 "show_external_trend_active"
                      //               );
                      //             document.querySelector(
                      //               ".show_tagId"
                      //             ).innerHTML = x.tagId;
                      //             var popup = document.querySelector(
                      //               ".show_external_trend"
                      //             );
                      //             const popupRect =
                      //               popup.getBoundingClientRect();
                      //             const viewportWidth = window.innerWidth;
                      //             const viewportHeight = window.innerHeight;

                      //             // Calculate the new positions
                      //             let newX = clientX;
                      //             let newY = clientY;

                      //             // Adjust if the popup would overflow the right edge of the viewport
                      //             if (newX + popupRect.width > viewportWidth) {
                      //               newX = viewportWidth - popupRect.width;
                      //             }

                      //             // Adjust if the popup would overflow the bottom edge of the viewport
                      //             if (
                      //               newY + popupRect.height >
                      //               viewportHeight
                      //             ) {
                      //               newY = viewportHeight - popupRect.height;
                      //             }

                      //             // Adjust if the popup would overflow the left edge of the viewport
                      //             if (newX < 0) {
                      //               newX = 0;
                      //             }

                      //             // Adjust if the popup would overflow the top edge of the viewport
                      //             if (newY < 0) {
                      //               newY = 0;
                      //             }

                      //             // Set the position of the popup
                      //             popup.style.left = `${newX}px`;
                      //             popup.style.top = `${newY}px`;
                      //           }}
                      //           labelId={`oda${roomNumber}-filtre-durumu-label`}
                      //           id={`oda${roomNumber}-filtre-durumu-select`}
                      //           className="filtre-durum-class"
                      //           displayEmpty
                      //           value={
                      //             filtredurumselectValue[active_room_number]
                      //           }
                      //           onChange={FiltreDurumSelectChange}
                      //           IconComponent={() => null}
                      //         >
                      //           <MenuItem
                      //             value={
                      //               filtredurumselectValue[active_room_number]
                      //             }
                      //           >
                      //             <em>
                      //               {filtredurumselectValue[active_room_number]}
                      //             </em>
                      //           </MenuItem>
                      //         </Select>
                      //       </FormControl>
                      //     </div>
                      //   );
                      // case "Filtre Reset":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(x.tagId))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];
                      //   return (
                      //     <div className={classes.statusRow}>
                      //       <Typography
                      //         variant="subtitle1"
                      //         className={classes.statusLabel}
                      //       >
                      //         {x.text.toUpperCase()}
                      //       </Typography>
                      //       <FormControl
                      //         variant="outlined"
                      //         className={classes.formControl}
                      //       >
                      //         <Button
                      //           disabled={!vrf_okuma_control}
                      //           onContextMenu={(e) => {
                      //             e.preventDefault();
                      //             const { clientX, clientY } = e;
                      //             var tagName = props.tag_list
                      //               .filter((b) => b.tagId === x.tagId)
                      //               .map((c) => c.tagName)[0];
                      //             document.querySelector(
                      //               ".show_tagName"
                      //             ).innerHTML = tagName;
                      //             document
                      //               .querySelector(".show_external_trend")
                      //               .classList.toggle(
                      //                 "show_external_trend_active"
                      //               );
                      //             document.querySelector(
                      //               ".show_tagId"
                      //             ).innerHTML = x.tagId;
                      //             var popup = document.querySelector(
                      //               ".show_external_trend"
                      //             );
                      //             const popupRect =
                      //               popup.getBoundingClientRect();
                      //             const viewportWidth = window.innerWidth;
                      //             const viewportHeight = window.innerHeight;

                      //             // Calculate the new positions
                      //             let newX = clientX;
                      //             let newY = clientY;

                      //             // Adjust if the popup would overflow the right edge of the viewport
                      //             if (newX + popupRect.width > viewportWidth) {
                      //               newX = viewportWidth - popupRect.width;
                      //             }

                      //             // Adjust if the popup would overflow the bottom edge of the viewport
                      //             if (
                      //               newY + popupRect.height >
                      //               viewportHeight
                      //             ) {
                      //               newY = viewportHeight - popupRect.height;
                      //             }

                      //             // Adjust if the popup would overflow the left edge of the viewport
                      //             if (newX < 0) {
                      //               newX = 0;
                      //             }

                      //             // Adjust if the popup would overflow the top edge of the viewport
                      //             if (newY < 0) {
                      //               newY = 0;
                      //             }

                      //             // Set the position of the popup
                      //             popup.style.left = `${newX}px`;
                      //             popup.style.top = `${newY}px`;
                      //           }}
                      //           labelId={`oda${roomNumber}-filtre-reset-label`}
                      //           id={`oda${roomNumber}-filtre-reset-buton`}
                      //           style={{
                      //             fontWeight: 600,

                      //             width: "155px",
                      //             padding: "1px 14px !important",
                      //             border: "2px solid #edbc45",
                      //             borderRadius: "4px",
                      //             color: "black",
                      //           }}
                      //           onClick={() => {
                      //             let tagId_;
                      //             state.forEach((a) => {
                      //               if (
                      //                 a[String(active_room_number)] !==
                      //                 undefined
                      //               ) {
                      //                 tagId_ =
                      //                   a[String(active_room_number)][8].tagId;
                      //               }
                      //             });
                      //             if (render_state.length > 0) {
                      //               render_state.forEach((x) => {
                      //                 if (x.tagId === String(tagId_)) {
                      //                   setfiltreselectSelectValue(
                      //                     (prevValues) => ({
                      //                       ...prevValues,
                      //                       [roomNumber]: "TEMİZ",
                      //                     })
                      //                   );
                      //                   sendSetValueFunc({
                      //                     TagId: String(tagId_),
                      //                     TagValue: x.tagValue.trim(),
                      //                   });
                      //                 }
                      //               });
                      //             }
                      //           }}
                      //         >
                      //           RESET
                      //         </Button>
                      //       </FormControl>
                      //     </div>
                      //   );

                      case "Arıza Durumu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];

                        const arizaDurumuText =
                          değerler_eleman === "1 " ? "ARIZA" : "NORMAL";

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {x.text.toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <Select
                                disabled
                                value={arizaDurumuText}
                                onContextMenu={(e) => {
                                  e.preventDefault();
                                  const { clientX, clientY } = e;
                                  var tagName = props.tag_list
                                    .filter((b) => b.tagId === x.tagId)
                                    .map((c) => c.tagName)[0];
                                  document.querySelector(
                                    ".show_tagName"
                                  ).innerHTML = tagName;
                                  document
                                    .querySelector(".show_external_trend")
                                    .classList.toggle(
                                      "show_external_trend_active"
                                    );
                                  document.querySelector(
                                    ".show_tagId"
                                  ).innerHTML = x.tagId;
                                  var popup = document.querySelector(
                                    ".show_external_trend"
                                  );
                                  const popupRect =
                                    popup.getBoundingClientRect();
                                  const viewportWidth = window.innerWidth;
                                  const viewportHeight = window.innerHeight;

                                  // Calculate the new positions
                                  let newX = clientX;
                                  let newY = clientY;

                                  // Adjust if the popup would overflow the right edge of the viewport
                                  if (newX + popupRect.width > viewportWidth) {
                                    newX = viewportWidth - popupRect.width;
                                  }

                                  // Adjust if the popup would overflow the bottom edge of the viewport
                                  if (
                                    newY + popupRect.height >
                                    viewportHeight
                                  ) {
                                    newY = viewportHeight - popupRect.height;
                                  }

                                  // Adjust if the popup would overflow the left edge of the viewport
                                  if (newX < 0) {
                                    newX = 0;
                                  }

                                  // Adjust if the popup would overflow the top edge of the viewport
                                  if (newY < 0) {
                                    newY = 0;
                                  }

                                  // Set the position of the popup
                                  popup.style.left = `${newX}px`;
                                  popup.style.top = `${newY}px`;
                                }}
                                id={`oda${roomNumber}-ariza-durumu-select`}
                                className="ariza-durum-class"
                                style={{
                                  color: "rgb(47, 47, 47)",
                                  fontWeight: 600,
                                  textAlign: "center",
                                  width: "100%",
                                }}
                              >
                                <MenuItem value={arizaDurumuText}>
                                  <em className="ariza-durum-text">
                                    {arizaDurumuText}
                                  </em>
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </div>
                        );

                      case "Arıza Kodu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(x.tagId))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        console.log(değerler_eleman);
                        const arizaKoduText =
                          {
                            1: "NORMAL",
                            2: "OTHER ERRORS",
                            3: "REFRIGERATION SYSTEM FAULT",
                            4: "WATER SYSTEM ERROR",
                            5: "AIR SYSTEM ERROR",
                            6: "ELECTRONIC SYSTEM ERROR",
                            7: "SENSOR FAULT",
                            8: "COMMUNICATION ERROR",
                            9: "SYSTEM ERROR",
                          }[değerler_eleman ? değerler_eleman.trim() : ""] ||
                          "BILINMEYEN";

                        return (
                          <div>
                            <div className={classes.statusRow}>
                              <Typography
                                variant="subtitle1"
                                className={classes.statusLabel}
                                style={{ flex: 1, textAlign: "left" }} // Yazıyı sola yaslar
                              >
                                ARIZA KODU
                              </Typography>
                              <FormControl
                                variant="outlined"
                                className={classes.formControl}
                              >
                                <Select
                                  disabled
                                  value={arizaKoduText}
                                  onContextMenu={(e) => {
                                    e.preventDefault();
                                    const { clientX, clientY } = e;
                                    var tagName = props.tag_list
                                      .filter((b) => b.tagId === x.tagId)
                                      .map((c) => c.tagName)[0];
                                    document.querySelector(
                                      ".show_tagName"
                                    ).innerHTML = tagName;
                                    document
                                      .querySelector(".show_external_trend")
                                      .classList.toggle(
                                        "show_external_trend_active"
                                      );
                                    document.querySelector(
                                      ".show_tagId"
                                    ).innerHTML = x.tagId;
                                    var popup = document.querySelector(
                                      ".show_external_trend"
                                    );
                                    const popupRect =
                                      popup.getBoundingClientRect();
                                    const viewportWidth = window.innerWidth;
                                    const viewportHeight = window.innerHeight;

                                    // Calculate the new positions
                                    let newX = clientX;
                                    let newY = clientY;

                                    // Adjust if the popup would overflow the right edge of the viewport
                                    if (
                                      newX + popupRect.width >
                                      viewportWidth
                                    ) {
                                      newX = viewportWidth - popupRect.width;
                                    }

                                    // Adjust if the popup would overflow the bottom edge of the viewport
                                    if (
                                      newY + popupRect.height >
                                      viewportHeight
                                    ) {
                                      newY = viewportHeight - popupRect.height;
                                    }

                                    // Adjust if the popup would overflow the left edge of the viewport
                                    if (newX < 0) {
                                      newX = 0;
                                    }

                                    // Adjust if the popup would overflow the top edge of the viewport
                                    if (newY < 0) {
                                      newY = 0;
                                    }

                                    // Set the position of the popup
                                    popup.style.left = `${newX}px`;
                                    popup.style.top = `${newY}px`;
                                  }}
                                  id={`oda${roomNumber}-ariza-kodu-select`}
                                  className="ariza-durum-class"
                                  style={{
                                    color: "rgb(47, 47, 47)",
                                    fontWeight: 600,
                                    textAlign: "center",
                                    width: "100%",
                                  }}
                                >
                                  <MenuItem value={arizaKoduText}>
                                    <em className="ariza-durum-text">
                                      {arizaKoduText}
                                    </em>
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                            <button
                              onClick={() => {
                                let tagidsData = [];
                                initalState.forEach((a) => {
                                  Object.entries(a).forEach((x) => {
                                    if (String(active_room_number) === x[0]) {
                                      x[1].forEach((b) => {
                                        tagidsData.push({
                                          tagName: b.text,
                                          tagId: b.tagId,
                                        });
                                      });
                                    }
                                  });
                                });

                                Store.dispatch(set_combine_trends(tagidsData));
                                history.push("/raporlama");
                              }}
                              className="combine-trend_btn_vrf"
                              style={{
                                marginTop: "10px",
                                width: "100%",
                                margin: "0",
                                padding: "10px",
                              }}
                            >
                              KOMBİNE TREND
                            </button>
                            ;
                          </div>
                        );
                    }
                  })}
                </div>
              );
            }
          })}
        </div>
        {setDegerleri && (
          <div className="save_changes vrf-popup-save-changes">
            <p className="ofjs">Değişikleri Kaydet</p>
            <div className="btn-group">
              <i
                onClick={() => {
                  try {
                    for (let i of changed_values) {
                      console.log("for içi i = ", i);
                      if (i === "Fan") {
                        //Fan Modu
                        let tagId_44;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_44 = a[String(active_room_number)][5].tagId2;
                          }
                        });

                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_44)) {
                              let fanValue;
                              switch (
                                fanmoduselectValue[String(active_room_number)]
                              ) {
                                case "DÜŞÜK":
                                  fanValue = "1 ";
                                  break;
                                case "HIZLI":
                                  fanValue = "2 ";
                                  break;
                                case "ORTA 2":
                                  fanValue = "3 ";
                                  break;
                                case "ORTA":
                                  fanValue = "4 ";
                                  break;
                                case "AUTO":
                                  fanValue = "5 ";
                                  break;
                                default:
                                  fanValue = "5 "; // Default olarak AUTO
                              }

                              sendSetValueFunc({
                                TagId: String(tagId_44),
                                TagValue: fanValue,
                              });
                            }
                          });
                        }
                      } else if (i === "Çalışma") {
                        //Çalışma Modu

                        let tagId_33;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_33 = a[String(active_room_number)][3].tagId2;
                          }
                        });
                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_33)) {
                              sendSetValueFunc({
                                TagId: String(tagId_33),
                                TagValue:
                                  calismamoduselectValue[
                                    String(active_room_number)
                                  ] === "ISITMA"
                                    ? "2"
                                    : calismamoduselectValue[
                                        String(active_room_number)
                                      ] === "SOĞUTMA"
                                    ? "1"
                                    : calismamoduselectValue[
                                        String(active_room_number)
                                      ] === "NEM ALMA"
                                    ? "5"
                                    : calismamoduselectValue[
                                        String(active_room_number)
                                      ] === "FAN"
                                    ? "3"
                                    : "AUTO",
                              });
                            }
                          });
                        }
                      } else if (i === "Cihaz") {
                        //Cihaz

                        let tagId_22;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_22 = a[String(active_room_number)][2].tagId2;
                          }
                        });
                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_22)) {
                              sendSetValueFunc({
                                TagId: String(tagId_22),
                                TagValue:
                                  cihazselectValue[
                                    String(active_room_number)
                                  ] === "OFF"
                                    ? "0 "
                                    : "1 ",
                              });
                            }
                          });
                        }
                      } else if (i === "SET") {
                        //Oda Set Değeri
                        let tagId_;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_ = a[String(active_room_number)][1].tagId;
                          }
                        });
                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_)) {
                              sendSetValueFunc({
                                TagId: String(tagId_),
                                TagValue: String(
                                  odasetdegerler[active_room_number]
                                ),
                              });
                            }
                          });
                        }
                        handleOdaSetDegeriDone(roomNumber);
                      } else if (i === "Soğutma") {
                        //Soğutma Modu Set Değeri

                        let tagId_2;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_2 = a[String(active_room_number)][5].tagId;
                          }
                        });
                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_2)) {
                              sendSetValueFunc({
                                TagId: String(tagId_2),
                                TagValue: String(
                                  sogutmamoduSet[active_room_number]
                                ),
                              });
                            }
                          });
                        }
                      } else if (i === "Isıtma") {
                        //Isıtma Set Değeri

                        let tagId_3;
                        state.forEach((a) => {
                          if (a[String(active_room_number)] !== undefined) {
                            tagId_3 = a[String(active_room_number)][6].tagId;
                          }
                        });
                        if (render_state.length > 0) {
                          render_state.forEach((x) => {
                            if (x.tagId === String(tagId_3)) {
                              sendSetValueFunc({
                                TagId: String(tagId_3),
                                TagValue: String(
                                  ısıtmamoduSet[active_room_number]
                                ),
                              });
                            }
                          });
                        }

                        SETSetDegerleri(false);
                      }
                    }
                    console.log("Changed VALUES === ", changed_values);
                    Set_changed_values([]);
                  } catch (err) {
                    console.log(err);
                  } finally {
                    SETSetDegerleri(false);
                  }
                }}
                className="fa fa-check"
              ></i>
              <i
                onClick={() => {
                  SETSetDegerleri(false);
                }}
                className="fa fa-times"
              ></i>
            </div>
          </div>
        )}
      </div>
    );
  };

  const [setDegerleri2, SETSetDegerleri2] = useState(false);

  const renderModalContent2 = (roomNumber) => {
    return (
      <div className={classes.paper + " vrf-popup-kapsayici"}>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => {
            Set_active_rm2(false);
            SETSetDegerleri2(false);
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="h2"
          style={{ color: "rgb(28,28,28)" }}
          gutterBottom
          id="oda-pop-up-baslik"
        >
          {"ORTAK HACİM GENEL SİSTEM"}
        </Typography>
        <div className="vrf-popup-select">
          {Object.entries(revisedState).map((item, index) => {
            console.log(item);
            var title = [];
            var obj_ = [];
            Object.entries(item).forEach((a) => {
              console.log(a, roomNumber);
              if (a[0] === String(roomNumber)) {
                title.push(a[0]);
                obj_.push(a[1]);
              }
            });
            return (
              <div style={{ width: "100%", marginRight: "16px" }}>
                {item.map((x, index) => {
                  if (index < 1) {
                    switch (item[0]) {
                      case "Oda Set Değeri":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        const genel_oda_set_değeri = değerler_eleman;
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              {item[0].toUpperCase()}
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              style={{ minWidth: "120px" }}
                            >
                              <Input
                                labelId={`oda${roomNumber}-oda-set-degeri-label`}
                                id={`oda-set-degeri-input-all`}
                                sx={{ fontWeight: 600 }}
                                type="number"
                                disabled={
                                  locked[roomNumber]?.odasetdegeri ||
                                  !vrf_okuma_control
                                }
                                onChange={(e) => {
                                  Set_active(true);
                                  SETSetDegerleri2(true);
                                  genel_value_changes("SET", 20);
                                  değerler_eleman = e.target.value;
                                }}
                                endAdornment={
                                  <InputAdornment
                                    className="vrf-derece"
                                    position="end"
                                  >
                                    °C
                                  </InputAdornment>
                                }
                              />
                            </FormControl>
                            <IconButton
                              onClick={() =>
                                toggleLock(roomNumber, "odasetdegeri")
                              }
                              className={classes.lockButton}
                              style={{
                                transform:
                                  initialOdasetdegerler[roomNumber] !==
                                  odasetdegerler[roomNumber]
                                    ? "scale(0.7)"
                                    : "scale(1)",
                              }}
                            >
                              {locked[roomNumber]?.odasetdegeri ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );
                      case "Cihaz":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);

                        var değerler_eleman = değerler[0];

                        var cihazRengi =
                          değerler_eleman === "0 " ? "gray" : "green";

                        // CihazState değerine göre yuvarlağın rengini belirleme

                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              CİHAZ
                            </Typography>
                            <div
                              className="deviceStatusIndicator"
                              style={{
                                backgroundColor: cihazled[String(roomNumber)],
                              }}
                            ></div>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.device}
                            >
                              <div
                                style={{
                                  color:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "2px solid gray"
                                      : "2px solid rgb(23,23,23)",
                                  pointerEvents:
                                    locked[roomNumber]?.device ||
                                    !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "cihaz_modu_menu_active"
                                  );
                                }}
                                className="cihaz_modu_div"
                              >
                                {değerler_eleman === "0 " ? "OFF" : "ON"}
                              </div>
                              <ul className="cihaz_modu_menu">
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = cihazselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Cihaz", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "cihaz_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                    document.querySelector(
                                      ".deviceStatusIndicator"
                                    ).style.backgroundColor = "green";
                                  }}
                                >
                                  ON
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = cihazselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Cihaz", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "cihaz_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                    document.querySelector(
                                      ".deviceStatusIndicator"
                                    ).style.backgroundColor = "gray";
                                  }}
                                >
                                  OFF
                                </li>
                              </ul>
                            </FormControl>

                            <IconButton
                              onClick={() => toggleLock(roomNumber, "device")}
                              className={classes.lockButton}
                            >
                              {locked[roomNumber]?.device ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );
                      case "Çalışma Modu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              ÇALIŞMA MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                              disabled={locked[roomNumber]?.mode}
                            >
                              <div
                                style={{
                                  color:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "gray"
                                      : "",
                                  border:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "2px solid gray"
                                      : "2px solid rgb(23,23,23)",
                                  pointerEvents:
                                    locked[roomNumber]?.mode ||
                                    !vrf_okuma_control
                                      ? "none"
                                      : "all",
                                  borderRadius: "4px",
                                }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "calisma_modu_menu_active"
                                  );
                                }}
                                className="calisma_modu_div"
                              >
                                {değerler_eleman === "2 "
                                  ? "ISITMA"
                                  : değerler_eleman === "1 "
                                  ? "SOĞUTMA"
                                  : değerler_eleman === "5 "
                                  ? "NEM ALMA"
                                  : "FAN"}
                              </div>
                              <ul className="calisma_modu_menu">
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;
                                    SETSetDegerleri2(true);

                                    genel_value_changes("Çalışma", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ISITMA
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;
                                    SETSetDegerleri2(true);

                                    genel_value_changes("Çalışma", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  SOĞUTMA
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Çalışma", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  NEM ALMA
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = calismamoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Çalışma", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "calisma_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  FAN
                                </li>
                              </ul>
                            </FormControl>

                            <IconButton
                              onClick={() => toggleLock(roomNumber, "mode")}
                              className={classes.lockButton}
                            >
                              {locked[roomNumber]?.mode ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );
                      case "Fan Modu":
                        var değerler = render_state
                          .filter((a) => String(a.tagId) === String(item[1][0]))
                          .map((b) => b.tagValue);
                        var değerler_eleman = değerler[0];
                        return (
                          <div className={classes.statusRow}>
                            <Typography
                              variant="subtitle1"
                              className={classes.statusLabel}
                            >
                              FAN MODU
                            </Typography>
                            <FormControl
                              variant="outlined"
                              className={classes.formControl}
                            >
                              <div
                                style={{
                                  right: "1%",
                                  color: !vrf_okuma_control ? "gray" : "",
                                  border: !vrf_okuma_control
                                    ? "2px solid gray"
                                    : "2px solid rgb(23,23,23)",
                                  pointerEvents: !vrf_okuma_control
                                    ? "none"
                                    : "all",
                                  borderRadius: "4px",
                                }}
                                onClick={(e) => {
                                  e.target.nextElementSibling.classList.toggle(
                                    "fan_modu_menu_active"
                                  );
                                }}
                                className="fan_modu_div"
                              >
                                {değerler_eleman === "1 "
                                  ? "DÜŞÜK"
                                  : değerler_eleman === "2 "
                                  ? "HIZLI"
                                  : değerler_eleman === "3 "
                                  ? "ORTA 2"
                                  : değerler_eleman === "4 "
                                  ? "ORTA"
                                  : değerler_eleman === "5 "
                                  ? "AUTO"
                                  : değerler_eleman}
                              </div>
                              <ul className="fan_modu_menu">
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    genel_value_changes("Fan", textCurrent);

                                    SETSetDegerleri2(true);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  DÜŞÜK
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  HIZLI
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);
                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA 2
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  ORTA{" "}
                                </li>
                                <li
                                  onClick={(e) => {
                                    var textCurrent = e.target.textContent;
                                    var newObj = fanmoduselectValue;
                                    newObj[roomNumber] = textCurrent;

                                    SETSetDegerleri2(true);

                                    genel_value_changes("Fan", textCurrent);

                                    e.target.parentElement.classList.toggle(
                                      "fan_modu_menu_active"
                                    );
                                    e.target.parentElement.previousElementSibling.innerHTML =
                                      textCurrent;
                                  }}
                                >
                                  AUTO{" "}
                                </li>
                              </ul>
                            </FormControl>
                            <IconButton
                              onClick={() =>
                                toggleLock(roomNumber, "odasetdegeri")
                              }
                              className={classes.lockButton}
                              style={{
                                transform:
                                  initialOdasetdegerler[roomNumber] !==
                                  odasetdegerler[roomNumber]
                                    ? "scale(0.7)"
                                    : "scale(1)",
                              }}
                            >
                              {locked[roomNumber]?.odasetdegeri ? (
                                <LockIcon />
                              ) : (
                                <LockOpenIcon />
                              )}
                            </IconButton>
                          </div>
                        );

                      // case "Filtre Reset":
                      //   var değerler = render_state
                      //     .filter((a) => String(a.tagId) === String(item[1][0]))
                      //     .map((b) => b.tagValue);
                      //   var değerler_eleman = değerler[0];
                      //   return (
                      //     <div className={classes.statusRow}>
                      //       <Typography
                      //         variant="subtitle1"
                      //         className={classes.statusLabel}
                      //       >
                      //         {item[0].toUpperCase()}
                      //       </Typography>
                      //       <FormControl
                      //         variant="outlined"
                      //         className={classes.formControl}
                      //       >
                      //         <Button
                      //           disabled={!vrf_okuma_control}
                      //           labelId={`oda${roomNumber}-filtre-reset-label`}
                      //           id={`oda${roomNumber}-filtre-reset-buton`}
                      //           style={{
                      //             fontWeight: 600,
                      //             height: "2.5rem",
                      //             backgroundColor: "green",
                      //             width: "10rem",
                      //             fontSize: "1rem",
                      //             border: "2px solid black",
                      //             borderRadius: "4px",
                      //             color: "rgb(255, 255, 255)",
                      //           }}
                      //           onClick={() => {
                      //             değerler_eleman = değerler_eleman.slice(
                      //               0,
                      //               -1
                      //             );
                      //             revisedState["Filtre Reset"].forEach(
                      //               async (i) => {
                      //                 await sendSetValueFunc({
                      //                   TagId: i,
                      //                   TagValue: değerler_eleman,
                      //                 });
                      //               }
                      //             );
                      //           }}
                      //         >
                      //           RESET
                      //         </Button>
                      //       </FormControl>
                      //     </div>
                      //   );
                    }
                  }
                })}
              </div>
            );
          })}
        </div>
        {setDegerleri2 && (
          <div className="save_changes vrf-popup-save-changes">
            <p className="ofjs">Değişikleri Kaydet</p>
            <div className="btn-group">
              <i
                onClick={() => {
                  console.log("aa");
                  try {
                    for (let i of changed_values2) {
                      console.log(i);
                      if (i.type === "Fan") {
                        // Fan Modu
                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Fan Modu") {
                                let tagValue;

                                // Fan değerlerini belirle
                                switch (i.value) {
                                  case "DÜŞÜK":
                                    tagValue = "1 ";
                                    break;
                                  case "HIZLI":
                                    tagValue = "2 ";
                                    break;
                                  case "ORTA 2":
                                    tagValue = "3 ";
                                    break;
                                  case "ORTA":
                                    tagValue = "4 ";
                                    break;
                                  case "AUTO":
                                    tagValue = "5 ";
                                    break;
                                  default:
                                    tagValue = "5 "; // Default olarak AUTO
                                }

                                // Fake API çağrısını gönder
                                sendSetValueFunc({
                                  TagId: String(element.tagId2),
                                  TagValue: tagValue,
                                });
                              }
                            });
                          });

                          // Fan seçilen değerleri güncelle
                          const fanValue = i.value === "5" ? "AUTO" : i.value;
                          setfanmoduSelectValue({
                            801: fanValue,
                            802: fanValue,
                            803: fanValue,
                            804: fanValue,
                            805: fanValue,
                            806: fanValue,
                            807: fanValue,
                            808: fanValue,
                            809: fanValue,
                            810: fanValue,
                            811: fanValue,
                            812: fanValue,
                            813: fanValue,
                            814: fanValue,
                            815: fanValue,
                            816: fanValue,
                          });
                        });
                      } else if (i.type === "Çalışma") {
                        //Çalışma Modu

                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Çalışma Modu") {
                                sendSetValueFunc({
                                  TagId: String(element.tagId2),
                                  TagValue: String(
                                    i.value === "ISITMA"
                                      ? "2 "
                                      : i.value === "SOĞUTMA"
                                      ? "1 "
                                      : i.value === "NEM ALMA"
                                      ? "5 "
                                      : "3 "
                                  ),
                                });
                              }
                            });
                          });
                          setcalismamoduSelectValue({
                            801: i.value,
                            802: i.value,
                            803: i.value,
                            804: i.value,
                            805: i.value,
                            806: i.value,
                            807: i.value,
                            808: i.value,
                            809: i.value,
                            810: i.value,
                            811: i.value,
                            812: i.value,
                            813: i.value,
                            814: i.value,
                            815: i.value,
                            816: i.value,
                          });
                        });
                      } else if (i.type === "Cihaz") {
                        //Cihaz
                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Cihaz") {
                                sendSetValueFunc({
                                  TagId: String(element.tagId2),
                                  TagValue: String(
                                    i.value === "OFF" ? "0 " : "1 "
                                  ),
                                });
                              }
                            });
                          });
                          setcihazSelectValue({
                            801: i.value,
                            802: i.value,
                            803: i.value,
                            804: i.value,
                            805: i.value,
                            806: i.value,
                            807: i.value,
                            808: i.value,
                            809: i.value,
                            810: i.value,
                            811: i.value,
                            812: i.value,
                            813: i.value,
                            814: i.value,
                            815: i.value,
                            816: i.value,
                          });

                          Setcihazled({
                            801: i.value === "ON" ? "green" : "gray",
                            802: i.value === "ON" ? "green" : "gray",
                            803: i.value === "ON" ? "green" : "gray",
                            804: i.value === "ON" ? "green" : "gray",
                            805: i.value === "ON" ? "green" : "gray",
                            806: i.value === "ON" ? "green" : "gray",
                            807: i.value === "ON" ? "green" : "gray",
                            808: i.value === "ON" ? "green" : "gray",
                            809: i.value === "ON" ? "green" : "gray",
                            810: i.value === "ON" ? "green" : "gray",
                            811: i.value === "ON" ? "green" : "gray",
                            812: i.value === "ON" ? "green" : "gray",
                            813: i.value === "ON" ? "green" : "gray",
                            814: i.value === "ON" ? "green" : "gray",
                            815: i.value === "ON" ? "green" : "gray",
                            816: i.value === "ON" ? "green" : "gray",
                          });
                        });
                      } else if (i.type === "SET") {
                        //Oda Set Değeri
                        let value_all_set = document.querySelector(
                          "#oda-set-degeri-input-all"
                        ).value;

                        initalState.forEach((item) => {
                          Object.values(item).forEach((values) => {
                            values.forEach((element) => {
                              if (element.text === "Oda Set Değeri") {
                                sendSetValueFunc({
                                  TagId: String(element.tagId),
                                  TagValue: String(value_all_set),
                                });
                              }
                            });
                          });
                        });

                        setOdasetdegerler({
                          801: String(value_all_set),
                          802: String(value_all_set),
                          803: String(value_all_set),
                          804: String(value_all_set),
                          805: String(value_all_set),
                          806: String(value_all_set),
                          807: String(value_all_set),
                          808: String(value_all_set),
                          809: String(value_all_set),
                          810: String(value_all_set),
                          811: String(value_all_set),
                          812: String(value_all_set),
                          813: String(value_all_set),
                          814: String(value_all_set),
                          815: String(value_all_set),
                          816: String(value_all_set),
                        });
                      }
                    }
                    Set_changed_values2([]);
                  } catch (err) {
                    console.log(err);
                  } finally {
                    SETSetDegerleri2(false);
                  }
                }}
                className="fa fa-check"
              ></i>
              <i
                onClick={() => {
                  SETSetDegerleri2(false);
                }}
                className="fa fa-times"
              ></i>
            </div>
          </div>
        )}
      </div>
    );
  };
  const day_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let todayFormatted = formatDate(today);
      let yesterdayFormatted = formatDate(yesterday);

      let newObj = {
        inital_date: yesterdayFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };
      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };

  const month_trend = (e) => {
    e.preventDefault();

    function formatDate(date) {
      let year = date.getFullYear();
      let month = padZero(date.getMonth() + 1);
      let day = padZero(date.getDate());
      return `${year}-${month}-${day}`;
    }

    function padZero(value) {
      return value < 10 ? "0" + value : value;
    }

    try {
      let today = new Date();
      let tagId_ = document.querySelector(".show_tagId").textContent;

      let lastMonth = new Date(today);
      lastMonth.setMonth(today.getMonth() - 1);

      let todayFormatted = formatDate(today);
      let lastMonthFormatted = formatDate(lastMonth);

      console.log(todayFormatted, lastMonthFormatted);
      //

      let newObj = {
        inital_date: lastMonthFormatted,
        tagId: tagId_,
        last_date: todayFormatted,
      };

      let newarray = [];
      newarray.push(newObj);
      Store.dispatch(set_external_trend_info(newarray));

      history.push("/raporlama");
    } catch (err) {
      console.log(err);
    }
  };
  const close_pop_up = (e) => {
    e.preventDefault();

    document
      .querySelector(".show_external_trend")
      .classList.toggle("show_external_trend_active");
  };

  const roomNames = {
    801: "Lobi",
    802: "Desk Üstü",
    803: "Güvenlik Ofisi",
    804: "Bulaşıkhane",
    805: "Yemekhane 1",
    806: "Yemekhane 2",
    807: "FOR FUN BAR",
    808: "FOR FUN WC",
    809: "FOR FUN WC 2",
    810: "KARAOKE 1",
    811: "DANS ODASI",
    812: "KARAOKE 2",
    813: "OYUN SALONU ÖNÜ",
  };

  const getTagIdForRoomCihaz = (roomNumber) => {
    const tagIdMap = {
      801: "1341",
      802: "1345",
      803: "1349",
      804: "1353",
      805: "1357",
      806: "1361",
      807: "1365",
      808: "1369",
      809: "1373",
      810: "1377",
      811: "1381",
      812: "1385",
      813: "1389",
    };
    return tagIdMap[roomNumber] || null;
  };

  const getTagIdForRoomOperationMode = (roomNumber) => {
    const tagIdMap = {
      801: "2702",
      802: "2706",
      803: "2710",
      804: "2714",
      805: "2718",
      806: "2722",
      807: "2726",
      808: "2730",
      809: "8732",
      810: "2738",
      811: "2742",
      812: "2746",
      813: "2750",
    };
    return tagIdMap[roomNumber] || null;
  };

  const getTagIdForRoomSetDeger = (roomNumber) => {
    const tagIdMap = {
      801: "1117",
      802: "1123",
      803: "1129",
      804: "1135",
      805: "1141",
      806: "1147",
      807: "1153",
      808: "1159",
      809: "1165",
      810: "1171",
      811: "1177",
      812: "1183",
      813: "1189",
    };
    return tagIdMap[roomNumber] || null;
  };

  const getTagIdForRoomAnlik = (roomNumber) => {
    const tagIdMap = {
      801: "973",
      802: "974",
      803: "975",
      804: "976",
      805: "977",
      806: "978",
      807: "979",
      808: "980",
      809: "981",
      810: "982",
      811: "983",
      812: "984",
      813: "985",
    };
    return tagIdMap[roomNumber] || null;
  };

  const getTagIdForRoomAriza = (roomNumber) => {
    const arizaTagIdMap = {
      801: "7234",
      802: "7237",
      803: "7240",
      804: "7243",
      805: "7246",
      806: "7249",
      807: "7252",
      808: "7255",
      809: "7258",
      810: "7261",
      811: "7264",
      812: "7267",
      813: "7270",
    };
    return arizaTagIdMap[roomNumber] || null;
  };

  return (
    <>
      <div className="show_pop_up show_external_trend">
        <i
          onClick={close_pop_up}
          style={{ position: "relative", left: "50%" }}
          className="fa fa-times close_tag_pop_up"
        ></i>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-around",
            width: "100%",
          }}
          className="top_flex"
        >
          <p>
            {" "}
            TagId: <span className="pop_up_x pop_up_external show_tagId"></span>
          </p>
          <p>
            {" "}
            TagName:{" "}
            <span className="pop_up_x pop_up_external show_tagName"></span>
          </p>
        </div>
        <div className="btn_area_popup_external">
          <button
            onClick={(e) => {
              day_trend(e);
            }}
          >
            Günlük Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              month_trend(e);
            }}
          >
            Aylık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
          <button
            onClick={(e) => {
              year_trend(e);
            }}
          >
            Yıllık Trend <i className="fa-solid fa-chart-line"></i>
          </button>
        </div>
      </div>
      <div className={classes.pageroot + " arkaplan"}>
        <div className={classes.topButtonContainer}>
          <button
            onClick={() => {
              Set_active_rm2(true);
            }}
            className="kat-bazı kat_bazı_vrf5"
          >
            ORTAK HACİM
          </button>
        </div>

        {active_rm2 && (
          <div key={"sistem1"}>
            <Modal
              aria-labelledby="transition-modal-title"
              aria-describedby="transition-modal-description"
              className={classes.modal}
              open={true}
              onClose={() => {}}
              closeAfterTransition
              BackdropComponent={Backdrop}
              BackdropProps={{
                timeout: 500,
              }}
            >
              {renderModalContent2("Sistem Kat-2")}
            </Modal>
          </div>
        )}
        <div className="move-main-vrf">
          <Link to="/VRF">
            <Button
              className={classes.navigationButtonBack + " movebuttonsvrf"}
              variant="contained"
            >
              ANA EKRAN
            </Button>
          </Link>
        </div>
        <div className="page-move-vrf">
          <Link to="/vrf5">
            <Button
              className={classes.navigationButtonBack + " movebuttonsvrf"}
              variant="contained"
            >
              Geri
            </Button>
          </Link>
          <Link to="/vrfks">
            <Button
              className={classes.navigationButtonForward + " movebuttonsvrf"}
              variant="contained"
            >
              İleri
            </Button>
          </Link>
        </div>

        <div className={classes.buttonContainer}>
          {open.map((isOpen, index) => {
            const roomNumber = 801 + index;
            const roomClass = `vrf-oda${roomNumber}`;
            const roomLabel = roomNames[roomNumber];

            // Cihaz durumunu belirleyen tagId
            const tagId = getTagIdForRoomCihaz(roomNumber);

            // Operation mode'ı belirleyen tagId
            const operationModeTagId = getTagIdForRoomOperationMode(roomNumber);

            // Set değerini belirleyen tagId
            const setDegerTagId = getTagIdForRoomSetDeger(roomNumber);

            // Yeni değeri belirleyen tagId
            const anlikTagId = getTagIdForRoomAnlik(roomNumber);

            // Arıza durumunu gösteren tagId
            const arizaTagId = getTagIdForRoomAriza(roomNumber);

            // Cihaz durumunu belirleyen render_state değerleri
            const değerler = render_state
              .filter((a) => String(a.tagId) === tagId)
              .map((b) => b.tagValue);
            const değerler_eleman = değerler[0];

            const normalizedCihazDurumu = değerler_eleman !== undefined
              ? (Number(değerler_eleman.toString().trim()) === 0 ? "0" : "1")
              : "0";
            const cihazDurumuText = normalizedCihazDurumu === "0" ? "OFF" : "ON";
            let cihazRengi =
              normalizedCihazDurumu === "0" ? "lightgray" : "rgb(237, 188, 69)";

            // Arıza durumunu belirleyen render_state değerleri
            const arizaDeğerler = render_state
              .filter((a) => String(a.tagId) === arizaTagId)
              .map((b) => b.tagValue);
            const arizaDurumu = arizaDeğerler[0];

            const normalizedArizaDurumu = arizaDurumu !== undefined
              ? (Number(arizaDurumu.toString().trim()) === 1 ? "1" : "0")
              : "0";
            // Eğer arıza durumu '1' ise cihaz rengi kırmızıya ayarlanır
            if (normalizedArizaDurumu === "1") {
              cihazRengi = "red";
            }

            // Operation mode'unu belirleyen render_state değerleri
            const operationModeDeğerler = render_state
              .filter((a) => String(a.tagId) === operationModeTagId)
              .map((b) => b.tagValue);
            const operationModeDeğer = operationModeDeğerler[0];

            const normalizedOperationMode = operationModeDeğer !== undefined
              ? String(Math.round(Number(operationModeDeğer.toString().trim())))
              : "0";

            // Set değerini belirleyen render_state değerleri
            const setDegerDeğerler = render_state
              .filter((a) => String(a.tagId) === setDegerTagId)
              .map((b) => b.tagValue);
            const setDeger = setDegerDeğerler[0];

            // Yeni değerini belirleyen render_state değerleri
            const newValueDeğerler = render_state
              .filter((a) => String(a.tagId) === anlikTagId)
              .map((b) => b.tagValue);
            const newValue = newValueDeğerler[0];

            // Operation mode'a göre renk ayarla
            let operationModeRengi = "gray"; // Varsayılan gri
            if (normalizedOperationMode === "1") {
              operationModeRengi = "cornflowerblue";
            } else if (normalizedOperationMode === "2") {
              operationModeRengi = "red";
            }

            return (
              <div key={roomNumber} className="vrf-buttonlar">
                <Button
                  className={`${classes.button} ${roomClass} vrfbuttons`}
                  onClick={() => {
                    Set_active_room_number(roomNumber);
                    handleOpen(index);
                  }}
                  style={{
                    backgroundColor: cihazRengi || cihazled[String(roomNumber)],
                  }}
                >
                  {`${roomLabel} `}

                  {/* Yeni değer için div */}
                  <span
                    style={{
                      position: "absolute",
                      right: "52%",
                      top: "40%",
                      border: "1px solid black",
                      padding: "4px",
                      borderRadius: "5px",
                      fontWeight: "bold",
                      fontSize: "0.8rem",
                    }}
                  >
                    {`ODA : ${newValue} °C`}
                  </span>

                  <div
                    className="operationmodeIndicator"
                    style={{
                      display: "inline-block",
                      backgroundColor: operationModeRengi,
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      marginLeft: "15%",
                      marginTop: "15%",
                    }}
                  ></div>

                  {/* SET : "değer" kısmı */}
                  <span
                    style={{
                      position: "absolute",
                      left: "67%",
                      top: "40%",
                      border: "1px solid black",
                      borderRadius: "5px",
                      padding: "4px",
                      fontWeight: "bold",
                      fontSize: "0.8rem",
                    }}
                  >
                    {`SET : ${setDeger}`}
                  </span>
                </Button>
                <Modal
                  aria-labelledby="transition-modal-title"
                  aria-describedby="transition-modal-description"
                  className={classes.modal}
                  open={isOpen}
                  onClose={() => handleClose(index)}
                  closeAfterTransition
                  BackdropComponent={Backdrop}
                  BackdropProps={{
                    timeout: 500,
                  }}
                >
                  {renderModalContent(roomNumber)}
                </Modal>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

const MapStateToProps = (state) => {
  return {
    vrfhacim_tags: state.project_reducer.vrfhacim_tags,
    tag_list: state.project_reducer.tag_list,
    yetkilendirme: state.project_reducer.yetkilendirme_state,
    group_id: state.project_reducer.group_id,
    uid: state.auth_reducer.user_id,
  };
};

export default connect(MapStateToProps)(VRFHacim);
